<template>
  <div id="zoom_box">
    <div id="zoom_temp_box" class="temp_box" v-loading="loading">
      <div class="temp_l">
        <div class="temp_title">
          <i class="el-icon-arrow-left" @click="goBack"></i>
          <div class="temp_titlec">
            <div class="temp_titlem">{{ ruleForm.name }}</div>
            <div>分类：{{ showCategory(ruleForm.group) }}</div>
          </div>
          <i
            class="el-icon-setting"
            style="cursor: pointer"
            @click="dialogTemplVisible = true"
          ></i>
        </div>
        <div class="temp_l_scroll">
          <div class="temp_sku_box">
            <el-collapse value="1">
              <el-collapse-item title="颜色信息" name="1">
                <div
                  class="sku_item"
                  v-for="item in DesignTemplate"
                  :key="item.color_id"
                  :class="{
                    activeTemplate: curTemplate.color_id == item.color_id,
                  }"
                  @click="changeTemplate(item)"
                >
                  <span
                    class="color_box"
                    :style="{ background: item.ColorItem.hex_value }"
                  ></span>
                  {{ item.ColorItem.name_zh }} / {{ item.ColorItem.name_en }} /
                  {{ item.ColorItem.hex_value }}
                </div>
              </el-collapse-item>
            </el-collapse>
            <div class="temp_sku_add" @click="addColor()">
              <i class="el-icon-plus"></i> 添加其它颜色
            </div>
          </div>
          <div class="temp_sku_box">
            <el-collapse value="1">
              <el-collapse-item name="1">
                <template slot="title">
                  <span class="size_box">尺码信息</span> 裁件尺寸（cm）
                </template>
                <div class="sku_item" v-for="(size, index) in sizes">
                  <span class="size_box">{{ size.size }}</span>
                  <span
                    ><p v-for="item in size.cutpieces">
                      {{ item.name }} {{ item.width }}*{{ item.height }}
                    </p></span
                  >
                  <i class="el-icon-edit" @click="editSize(size, index)"></i
                  ><i
                    class="el-icon-delete"
                    style="cursor: pointer"
                    @click="delSize(index)"
                  ></i>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div class="temp_sku_add" @click="addSize()">
              <i class="el-icon-plus"></i> 添加其它尺码
            </div>
          </div>
        </div>
      </div>
      <div class="temp_c">
        <div class="temp_emptyout" v-if="!curTemplate.design_list?.length">
          <div class="temp_empty" @click="uploadImage">
            <img src="@/assets/images/empty.png" alt="" />
            <div>请添加效果图</div>
          </div>
        </div>
        <input
          type="file"
          accept="image/jpeg, image/png, image/jpg"
          @change="addImage($event)"
          ref="file"
          class="input-opacity"
          style="display: none"
        />
        <input
          type="file"
          accept="image/png"
          @change="addMask($event)"
          ref="maskfile"
          class="input-mask"
          style="display: none"
        />
        <div class="temp_banner" v-show="curTemplate.design_list?.length">
          <draggable
            class="temp_banner_t"
            v-model="curTemplate.design_list"
            handle=".temp_banner_img"
            @update="updateDraggable"
          >
            <transition-group tag="div" style="cursor: pointer">
              <div
                v-for="item in curTemplate.design_list"
                class="temp_banner_img"
                :key="item.url"
                :class="{ active: curDesign.id == item.id }"
                @click="changeDesign(item)"
              >
                <span class="temp_banner_del" @click.stop="deleteImage(item.id)"
                  ><i class="el-icon-close"></i
                ></span>
                <img :src="item.url" />
              </div>
            </transition-group>
          </draggable>
          <div class="temp_banner_add" @click="uploadImage()">
            <i class="el-icon-plus"></i> 添加轮播图
          </div>
        </div>
        <div
          class="temp_main"
          v-show="curTemplate.design_list?.length"
          @wheel="handleWheel"
        >
          <div
            class="copy"
            v-if="curTemplate.design_list && curTemplate.design_list.length > 1"
          >
            <p>复制至</p>
            <div class="copy-list">
              <div class="item" @click="copyCanvas('all')">全部</div>
              <div
                class="item"
                @click="copyCanvas(item)"
                v-for="(item, index) in curTemplate.design_list"
              >
                <a>轮播图{{ index + 1 }}</a>
              </div>
            </div>
          </div>
          <div
            id="container"
            ref="thcontainer"
            class="container"
            :style="{ cursor: spacePressed ? 'grab' : 'default' }"
          />
        </div>
        <div style="align-self: self-start">
          <div class="temp_resize" @click="cropimage">
            <img src="@/assets/images/resize.png" alt="" />
            <div>调整尺寸</div>
          </div>
          <div class="temp_resize" @click="resetStage">
            <i
              style="font-size: 40px; margin-bottom: 2px"
              class="el-icon-refresh"
            ></i>
            <div>重置画布</div>
          </div>
          <p>
            <el-dropdown>
              <el-button
                style="
                  background: #192038;
                  border: 0px;
                  margin-top: 35px;
                  width: 80px;
                  height: 40px;
                "
                type="primary"
                size="small"
              >
                快捷键
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="keylist">
                <el-dropdown-item v-for="cutkey in shortcutkey">
                  <div class="keydow">
                    <p>{{ cutkey.name }}</p>
                    <p class="keybox">{{ cutkey.display }}</p>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </p>
        </div>
      </div>
      <div class="temp_r">
        <el-button
          v-if="!isPreviewMask"
          :disabled="!curDesign"
          class="temp_add_print"
          @click="moren(printImgUrl)"
        >
          <i class="el-icon-plus"></i> 添加印花区域
        </el-button>
        <div class="temp_print_scroll" v-if="!isPreviewMask">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              v-if="
                layer &&
                layer.children &&
                layer.children.length > 0 &&
                item.attrs.image != undefined &&
                item.attrs.printing != undefined
              "
              class="temp_print_box"
              v-for="(item, index) in layer.children"
              :name="item.attrs.id"
              :key="index"
            >
              <span
                style="padding-bottom: 10px; display: block"
                @click="changesucai(index)"
                slot="label"
                ><i
                  class="el-icon-picture-outline"
                  style="margin-right: 2px"
                ></i
                >{{ item.attrs.printingname }}</span
              >
              <div @click="changesucai(index)">
                <div class="temp_print_t">
                  <div style="display: flex">
                    <el-input
                      :autofocus="true"
                      size="mini"
                      style="width: 100px"
                      @blur="item.attrs.editname = false"
                      v-if="item.attrs.editname"
                      v-model="item.attrs.printingname"
                    ></el-input>
                    <p v-else>
                      {{ item.attrs.printingname }}
                    </p>
                    <i
                      class="el-icon-edit"
                      v-if="!item.attrs.editname"
                      @click="item.attrs.editname = true"
                    ></i>
                  </div>
                  <div>
                    <el-tooltip
                      effect="light"
                      content="混合模式"
                      placement="bottom"
                    >
                      <el-select
                        size="mini"
                        style="width: 130px"
                        @change="changeGlobalCompositeOperation($event, item)"
                        v-model="item.attrs.globalCompositeOperation"
                        clearable
                        placeholder="请选择混合模式"
                      >
                        <el-option
                          label="正常(默认)"
                          value="source-over"
                        ></el-option>
                        <el-option
                          label="正片叠底(适合白色背景)"
                          value="multiply"
                        ></el-option>
                        <el-option
                          label="亮色(适合黑色背景)"
                          value="screen"
                        ></el-option>
                      </el-select>
                    </el-tooltip>
                  </div>
                  <div>
                    <i
                      class="el-icon-document-copy"
                      style="cursor: pointer"
                      @click="copyimg(index)"
                    ></i
                    ><i
                      class="el-icon-delete"
                      style="cursor: pointer"
                      @click="delimg(index)"
                    ></i>
                  </div>
                </div>
                <div class="temp_print_tip">印花填充样式</div>
                <div class="print_fill_out">
                  <div @click="item.attrs.oattrs?(item.attrs.oattrs.printing = 0,item.attrs.printing = 0):item.attrs.printing = 0">
                    <div
                      class="print_fill_item"
                      :class="{
                        active: item.attrs.printing == 0,
                      }"
                    >
                      <img src="@/assets/images/contain.png" alt="" />
                    </div>
                    <div class="temp_print_tip">适应印花位置</div>
                  </div>
                  <div @click="item.attrs.oattrs?(item.attrs.oattrs.printing = 1,item.attrs.printing = 1):item.attrs.printing = 1">
                    <div
                      class="print_fill_item"
                      :class="{
                        active: item.attrs.printing == 1,
                      }"
                    >
                      <img src="@/assets/images/cover.png" alt="" />
                    </div>
                    <div class="temp_print_tip">充满印花位置</div>
                  </div>
                  <div @click="item.attrs.oattrs?(item.attrs.oattrs.printing = 2,item.attrs.printing = 2):item.attrs.printing = 2">
                    <div
                      class="print_fill_item"
                      :class="{
                        active: item.attrs.printing == 2,
                      }"
                    >
                      <img src="@/assets/images/stretch.png" alt="" />
                    </div>
                    <div class="temp_print_tip">拉伸印花位置</div>
                  </div>
                </div>
                <div class="temp_print_tip" v-if="item.attrs.printing == 0">
                  印花对齐方式
                </div>
                <div v-if="item.attrs.printing == 0">
                  <el-radio-group
                    v-model="item.attrs.alignment"
                    @input="setAlignment($event,item)"
                    size="mini"
                    style="margin-top: 20px"
                  >
                    <el-radio-button label="1">上对齐</el-radio-button>
                    <el-radio-button label="2">下对齐</el-radio-button>
                    <el-radio-button label="0">居中</el-radio-button>
                    <el-radio-button label="3">左对齐</el-radio-button>
                    <el-radio-button label="4">右对齐</el-radio-button>
                  </el-radio-group>
                </div>
                <div class="temp_print_tip">印花透明度</div>
                <div>
                  <el-slider
                    v-model="lucency"
                    :format-tooltip="formatTooltip"
                  ></el-slider>
                </div>
                <div class="temp_print_tip">
                  印花变形<el-switch
                    v-model="item.attrs.Deformation"
                    style="margin-left: 30px"
                    @change="openDeformation($event, item)"
                    active-text="开启"
                    inactive-text=""
                    active-color="#409eff"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                  <el-button
                    type="primary"
                    size="mini"
                    style="margin-left: 30px"
                    v-if="
                      item.attrs.Deformation && item.attrs.corners != undefined
                    "
                    @click="openDeformation(true, item)"
                    ><i style="margin-right: 4px" class="el-icon-s-tools"></i
                    >调整变形</el-button
                  >
                </div>
                <div v-if="item.attrs.Deformation" style="margin-top: 20px">
                  <el-tag
                    v-if="item.attrs.corners != undefined"
                    size="samll"
                    type="warning"
                    style="margin-right: 20px"
                    >已设置变形(可调整)</el-tag
                  ><el-button
                    size="small"
                    v-if="item.attrs.oattrs != undefined"
                    type="warning"
                    @click="resetCorners(item)"
                    round
                    ><i
                      style="margin-right: 4px"
                      class="el-icon-refresh-right"
                    ></i
                    >重置变形</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="item.attrs.corners == undefined"
                    type="warning"
                    @click="openDeformation(true, item)"
                    >未设置变形(点击设置)</el-button
                  >
                </div>
                <div class="temp_print_tip">
                  印花褶皱<el-switch
                    v-model="item.attrs.Texture"
                    style="margin-left: 30px"
                    @change="openTexture($event, item)"
                    active-text="开启"
                    inactive-text=""
                    active-color="#409eff"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                  <el-button
                    type="primary"
                    size="mini"
                    style="margin-left: 30px"
                    v-if="item.attrs.Texture"
                    @click="openTexture(true, item)"
                    ><i style="margin-right: 4px" class="el-icon-s-tools"></i
                    >调整褶皱</el-button
                  >
                </div>
                <div v-if="item.attrs.Texture" style="margin-top: 20px">
                  <el-tag type="warning"
                    >褶皱深度:{{ item.attrs.TextureDepth }}</el-tag
                  >
                  <el-tag type="warning" style="margin-left: 10px"
                    >褶皱偏移:{{ item.attrs.TextureOffsetValue }}</el-tag
                  >
                  <el-tag type="warning" style="margin-left: 10px"
                    >阴影强度:{{ item.attrs.TextureShadowValue }}</el-tag
                  >
                </div>
                <div class="temp_print_tip">印花明暗</div>
                <div>
                  <el-slider
                    v-model="item.attrs.brightness"
                    :step="0.1"
                    @input="changeBrightness($event, item)"
                    :min="-1"
                    :max="1"
                  ></el-slider>
                </div>
                <div class="temp_print_tip">商品区域保护(蒙板)</div>
                <div
                  style="
                    display: flex;
                    margin-top: 20px;
                    justify-content: space-between;
                  "
                >
                  <div
                    style="
                      margin-top: 10px;
                      align-self: center;
                      min-width: 110px;
                    "
                  >
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="抠图蒙版"
                      placement="top"
                    >
                      <el-button
                        @click="imageCutout()"
                        :disabled="loading"
                        type="primary"
                        icon="el-icon-edit-outline"
                        circle
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="上传png蒙版"
                      placement="top"
                    >
                      <el-button
                        @click="uploadMask()"
                        type="primary"
                        icon="el-icon-upload2"
                        circle
                      ></el-button>
                    </el-tooltip>
                  </div>
                  <el-image
                    v-if="item.attrs.maskUrl"
                    style="width: 100%; height: 100px; border: solid 1px black"
                    :src="item.attrs.maskUrl"
                    :preview-src-list="[item.attrs.maskUrl]"
                    fit="contain"
                  ></el-image>
                  <el-tooltip
                    v-if="item.attrs.maskUrl"
                    class="item"
                    effect="light"
                    content="实时预览蒙版效果"
                    placement="top"
                  >
                    <el-button
                      style="
                        margin-top: 10px;
                        margin-left: 20px;
                        align-self: center;
                      "
                      @click="previewMask(true, item)"
                      type="warning"
                      icon="el-icon-view"
                      circle
                    ></el-button>
                  </el-tooltip>
                  <el-button
                    style="margin-top: 10px; align-self: center"
                    v-if="item.attrs.maskUrl"
                    @click="delmaskUrl(item)"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                  ></el-button>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="temp_print_scroll" v-else>
          <el-button class="temp_mask" @click="previewMask(false, curImg)"
            ><i class="el-icon-circle-check"></i>
            确认设计并关闭实时预览</el-button
          >
        </div>
        <el-button
          class="temp_save"
          v-if="!isPreviewMask"
          @click="saveTemplate()"
          >保存模版</el-button
        >
      </div>
    </div>
    <el-dialog
      class="main_dialog"
      :show-close="false"
      title="新增颜色"
      width="470px"
      :visible.sync="dialogColorVisible"
    >
      <el-button
        type="text"
        style="color: #f5f105"
        @click="showColorSelect = !showColorSelect"
        >{{ showColorSelect ? "新增其他颜色" : "选择已有颜色" }}</el-button
      >
      <div v-if="showColorSelect">
        <el-form label-position="top">
          <el-form-item label="颜色名称">
            <el-select
              v-model="colors"
              multiple
              filterable
              remote
              placeholder="请选择颜色"
              :remote-method="getColorList"
              :loading="colorloading"
              @change="colorsChange($event)"
            >
              <el-option
                v-for="item in colorList"
                :key="item.id"
                :label="item.name_zh"
                :value="item.id"
              >
                {{ item.name_zh
                }}<span
                  :style="{ background: item.hex_value }"
                  class="color_label"
                ></span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <el-form
          v-loading="colorloading"
          :model="colorForm"
          :rules="colorRules"
          label-position="top"
          ref="colorForm"
          hide-required-asterisk
        >
          <el-form-item label="颜色名称" prop="name_zh">
            <el-input
              v-model="colorForm.name_zh"
              placeholder="请填写颜色名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="英文名称" prop="name_en">
            <el-input
              v-model="colorForm.name_en"
              placeholder="请填写英文名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="颜色十六进制值" prop="hex_value">
            <el-input
              v-model="colorForm.hex_value"
              placeholder="请填写十六进制值"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button class="dialog_confirm" size="small" @click="handleSubmitForm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      class="main_dialog"
      :show-close="false"
      title="新增尺码信息"
      width="470px"
      :visible.sync="dialogSizeVisible"
    >
      <el-form :model="sizeform" label-position="top" ref="esizeForm">
        <el-form-item
          label="新增尺寸"
          prop="size"
          :rules="[{ required: true, message: '请输入尺寸', trigger: 'blur' }]"
        >
          <el-input v-model="sizeform.size" placeholder="请填写尺寸"></el-input>
        </el-form-item>
        <el-form-item label="裁件尺寸（cm）" v-for="item in sizeform.cutpieces">
          <el-input-number
            style="width: 200px"
            :controls="false"
            v-model="item.width"
            :placeholder="item.name + '裁件宽'"
          ></el-input-number>
          *
          <el-input-number
            style="width: 200px"
            :controls="false"
            v-model="item.height"
            :placeholder="item.name + '裁件高'"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <el-button class="dialog_confirm" size="small" @click="addSizeCutpiece"
        >确 定</el-button
      >
      <el-button
        class="dialog_cancel"
        size="small"
        @click="dialogSizeVisible = false"
        >取 消</el-button
      >
    </el-dialog>
    <el-dialog
      class="cropDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="dialogVisible"
      top="10px"
      width="680px"
      title="调整大小与比例"
      @open="show()"
      @close="closeCropper()"
      v-loading="croploading"
    >
      <div>
        <div class="cropper-content">
          <!-- 剪裁框 -->
          <div class="cropper">
            <img id="imagecrop" ref="imagecrop" :src="imgFile" alt="" />
          </div>
        </div>
        <div class="footer-btn">
          <!-- 缩放旋转按钮 -->
          <div class="scope-btn">
            <el-tooltip
              class="item"
              effect="dark"
              content="放大"
              placement="top"
            >
              <el-button icon="el-icon-zoom-in" @click="cropperzoom(0.05)" />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="缩小"
              placement="top"
            >
              <el-button icon="el-icon-zoom-out" @click="cropperzoom(-0.05)" />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="逆时针旋转"
              placement="top"
            >
              <el-button
                icon="el-icon-refresh-left"
                @click="cropperRotate(-90)"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="顺时针旋转"
              placement="top"
            >
              <el-button
                icon="el-icon-refresh-right"
                @click="cropperRotate(90)"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="重置画布"
              placement="top"
            >
              <el-button icon="el-icon-refresh" @click="cropperReset()" />
            </el-tooltip>
          </div>
          <div class="scope-btn" v-if="curDesign">
            <el-input-number
              style="width: 100px; align-self: center"
              v-model="curDesign.cropwidth"
              @change="setcropAspectRatio($event, curDesign.cropheight)"
              :controls="false"
              placeholder="W"
              :max="2048"
            >
            </el-input-number>
            <img src="@/assets/images/link.png" style="margin: 0 2%" />
            <el-input-number
              style="width: 100px; align-self: center"
              v-model="curDesign.cropheight"
              @change="setcropAspectRatio(curDesign.cropwidth, $event)"
              :controls="false"
              placeholder="H"
              :max="2048"
            >
            </el-input-number>
            <p style="align-self: center; color: white">px</p>
            <div class="sizeselect_box">
              <span style="flex-shrink: 0">推荐尺寸</span>
              <div class="size_box">
                <div
                  class="size_item"
                  @click="
                    (curDesign.cropwidth = 1340),
                      (curDesign.cropheight = 1785),
                      setcropAspectRatio(
                        curDesign.cropwidth,
                        curDesign.cropheight
                      )
                  "
                >
                  <img src="@/assets/images/temu.png" /> 1340*1785px
                </div>
              </div>
              <el-dropdown trigger="click">
                <el-button class="size_item">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu
                  slot="dropdown"
                  style="min-width: 256px;"
                >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="
                        (curDesign.cropwidth = 2000),
                          (curDesign.cropheight = 2000),
                          setcropAspectRatio(
                            curDesign.cropwidth,
                            curDesign.cropheight
                          )
                      "
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/amazon.png" />
                        <p>Amazon</p>
                      </div>
                      <p>2000*2000px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="
                        (curDesign.cropwidth = 1000),
                          (curDesign.cropheight = 1000),
                          setcropAspectRatio(
                            curDesign.cropwidth,
                            curDesign.cropheight
                          )
                      "
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/temu.png" />
                        <p>TEMU 通用</p>
                      </div>
                      <p>1000*1000px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="
                        (curDesign.cropwidth = 1340),
                          (curDesign.cropheight = 1785),
                          setcropAspectRatio(
                            curDesign.cropwidth,
                            curDesign.cropheight
                          )
                      "
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/temu.png" />
                        <p>TEMU 服装</p>
                      </div>
                      <p>1340*1785px | 3:4</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="
                        (curDesign.cropwidth = 2048),
                          (curDesign.cropheight = 2048),
                          setcropAspectRatio(
                            curDesign.cropwidth,
                            curDesign.cropheight
                          )
                      "
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/shopify.png" />
                        <p>Shopify</p>
                      </div>
                      <p>2048*2048px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="
                        (curDesign.cropwidth = 1024),
                          (curDesign.cropheight = 1024),
                          setcropAspectRatio(
                            curDesign.cropwidth,
                            curDesign.cropheight
                          )
                      "
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/tiktok.png" />
                        <p>Tiktok Shop</p>
                      </div>
                      <p>1024*1024px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="
                        (curDesign.cropwidth = 2000),
                          (curDesign.cropheight = 2000),
                          setcropAspectRatio(
                            curDesign.cropwidth,
                            curDesign.cropheight
                          )
                      "
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/shein.png" />
                        <p>SHEIN</p>
                      </div>
                      <p>2000*2000px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="
                        (curDesign.cropwidth = 1600),
                          (curDesign.cropheight = 1600),
                          setcropAspectRatio(
                            curDesign.cropwidth,
                            curDesign.cropheight
                          )
                      "
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/aliexpress.png" />
                        <p>AliExpress</p>
                      </div>
                      <p>1600*1600px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="
                        (curDesign.cropwidth = 800),
                          (curDesign.cropheight = 800),
                          setcropAspectRatio(
                            curDesign.cropwidth,
                            curDesign.cropheight
                          )
                      "
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/1688.png" />
                        <p>阿里巴巴</p>
                      </div>
                      <p>800*800px | 1:1</p>
                    </div></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="upload-btn">
            <el-button
              style="border: 1px solid #dcdfe6"
              @click="
                (curDesign.cropwidth = JSON.parse(
                  JSON.stringify(autoCropWidth)
                )),
                  (curDesign.cropheight = JSON.parse(
                    JSON.stringify(autoCropHeight)
                  )),
                  (dialogVisible = false)
              "
              >取消</el-button
            >
            <el-button
              type="primary"
              style="border: 1px solid #dcdfe6"
              @click="sureSava()"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="main_dialog"
      :show-close="false"
      title="编辑模板信息"
      top="70px"
      width="400px"
      :visible.sync="dialogTemplVisible"
    >
      <el-form :model="ruleForm" label-position="top">
        <el-form-item label="商品套图名称">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入商品套图的名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板分组">
          <el-select v-model="ruleForm.group" placeholder="请选择模板分组">
            <el-option
              v-for="item in classifyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="轮播图尺寸">
          <div class="sizeform_box">
            <el-input-number
              v-model="ruleForm.width"
              :controls="false"
              placeholder="W"
              :max="2048"
            >
            </el-input-number>
            <img src="@/assets/images/link.png" style="margin: 0 2%" />
            <el-input-number
              v-model="ruleForm.height"
              :controls="false"
              placeholder="H"
              :max="2048"
            >
            </el-input-number>
            <div class="sizeselect_box">
              <span style="flex-shrink: 0">推荐</span>
              <div class="size_box">
                <div
                  class="size_item"
                  @click="(ruleForm.width = 1000), (ruleForm.height = 1000)"
                >
                  <img src="@/assets/images/temu.png" /> 1000*1000px
                </div>
                <div
                  class="size_item"
                  @click="(ruleForm.width = 1340), (ruleForm.height = 1785)"
                >
                  <img src="@/assets/images/temu.png" /> 1340*1785px
                </div>
              </div>
              <el-dropdown trigger="click">
                <el-button class="size_item">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu
                  slot="dropdown"
                  style="min-width: 256px;"
                >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="(ruleForm.width = 2000), (ruleForm.height = 2000)"
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/amazon.png" />
                        <p>Amazon</p>
                      </div>
                      <p>2000*2000px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="(ruleForm.width = 1000), (ruleForm.height = 1000)"
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/temu.png" />
                        <p>TEMU 通用</p>
                      </div>
                      <p>1000*1000px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="(ruleForm.width = 1340), (ruleForm.height = 1785)"
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/temu.png" />
                        <p>TEMU 服装</p>
                      </div>
                      <p>1340*1785px | 3:4</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="(ruleForm.width = 2048), (ruleForm.height = 2048)"
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/shopify.png" />
                        <p>Shopify</p>
                      </div>
                      <p>2048*2048px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="(ruleForm.width = 1024), (ruleForm.height = 1024)"
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/tiktok.png" />
                        <p>Tiktok Shop</p>
                      </div>
                      <p>1024*1024px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="(ruleForm.width = 2000), (ruleForm.height = 2000)"
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/shein.png" />
                        <p>SHEIN</p>
                      </div>
                      <p>2000*2000px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="(ruleForm.width = 1600), (ruleForm.height = 1600)"
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/aliexpress.png" />
                        <p>AliExpress</p>
                      </div>
                      <p>1600*1600px | 1:1</p>
                    </div></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><div
                      class="size_option"
                      @click="(ruleForm.width = 800), (ruleForm.height = 800)"
                    >
                      <div class="size_box1">
                        <img src="@/assets/images/1688.png" />
                        <p>阿里巴巴</p>
                      </div>
                      <p>800*800px | 1:1</p>
                    </div></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="裁件分辨率 DPI">
          <el-select v-model="ruleForm.dpi" placeholder="请选择分辨率">
            <el-option
              v-for="item in dpiList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="图片涂抹分割"
      class="maskDialog"
      :visible.sync="maskdialogVisible"
      width="max-content"
      style="font-size: 0"
      top="5vh"
      @close="resetCanvas"
    >
      <div class="toolbar">
        <el-radio-group v-model="tool" size="small">
          <el-radio-button label="brush">涂抹</el-radio-button>
          <el-radio-button label="eraser">擦除</el-radio-button>
        </el-radio-group>

        <el-slider
          v-model="brushSize"
          :min="5"
          :max="200"
          style="width: 200px; margin-left: 20px; font-size: 0 !important"
        ></el-slider>
        <span class="size-label">笔刷大小: {{ brushSize }}px</span>

        <el-button
          type="danger"
          size="small"
          style="margin-left: 20px"
          @click="clearCanvas"
          >清空画布</el-button
        >
      </div>

      <div class="canvas-container">
        <canvas
          ref="displayCanvas"
          @mousedown="startDrawing"
          @mousemove="draw"
          @mouseup="stopDrawing"
          @mouseleave="stopDrawing"
        ></canvas>
        <div v-if="cropMaskimg != ''">
          <el-image
            style="width: 600px; height: 600px"
            :src="cropMaskimg"
            fit="contain"
          ></el-image>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="maskdialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="getMask"
          :disabled="cropMaskloading"
          v-loading="cropMaskloading"
          >生成蒙版</el-button
        >
        <el-button
          type="primary"
          @click="sureMask"
          :disabled="cropMaskloading || cropMaskimg == ''"
          >确认蒙版</el-button
        >
      </span>
    </el-dialog>
    <cut-out
      :visible="editorVisible"
      :image-url="curImgCutOut"
      @close="editorVisible = false"
      @confirm="sureMask2"
    ></cut-out>
    <Texture
      :visible="textureVisible"
      :model-url="curDesign ? curDesign.url : ''"
      :maskUrl="curImg&&curImg.attrs?curImg.attrs.maskUrl:''"
      :base-texture-url="curTexture"
      :depth="depth"
      :offset="offset"
      :shadow="shadow"
      @close="textureVisible = false"
      @confirm="sureTexture"
      @closeTexture="closeTexture"
    ></Texture>
    <Deformation
      v-if="deformVisible"
      :visible="deformVisible"
      :image="printImgUrl"
      :maskUrl="curImg&&curImg.attrs?curImg.attrs.maskUrl:''"
      :backgroundImage="curDesign ? curDesign.url : ''"
      :corners="curCorners"
      :setCorners="
        curImg&&curImg.attrs&&curImg.attrs.corners != undefined ? curImg.attrs.corners : []
      "
      :canvasWidth="curDesign ? curDesign.width : 790"
      :canvasHeight="curDesign ? curDesign.height : 790"
      @close="deformVisible = false"
      @confirm="sureDeformation"
    ></Deformation>
  </div>
</template>
<script>
import { konva } from "@/mixins";
import { clickTap, mouseMove } from "./methods/monitor";
import { dragmove } from "./methods/catch";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import { opacity } from "./methods/rightButton";
import CutOut from "./components/cutout";
import Texture from "./components/texture";
import Deformation from "./components/deformation";
import Konva from "konva";
import draggable from "vuedraggable";
import { debounceFun } from "@/utils/utils";
import {
  categoryGetList,
  colorGetList,
  templateUploadImage,
  templateCreate,
  templateDetail,
  templateUpdate,
  cutout,
  getSyncJob,
  uploadImage,
  segment,
  colorCreate,
  colorUpdate,
} from "@/api/template";
export default {
  name: "templateDetail",
  mixins: [konva],
  components: {
    CutOut,
    Texture,
    Deformation,
    draggable,
  },
  data() {
    return {
      deformVisible: false,
      curCorners: [],
      isZoomSupported: false,
      shortcutkey: [
        {
          name: "画布缩放",
          display: "鼠标滚轮",
        },
        {
          name: "画布拖拽",
          display: "空格+左键",
        },
        {
          name: "上移动",
          display: "↑",
        },
        {
          name: "下移动",
          display: "↓",
        },
        {
          name: "左移动",
          display: "←",
        },
        {
          name: "右移动",
          display: "→",
        },
        {
          name: "撤回",
          display: "Ctrl+Z",
        },
        {
          name: "重做",
          display: "Ctrl+Y",
        },
        {
          name: "删除",
          display: "Delete",
        },
        {
          name: "复制",
          display: "Ctrl+C",
        },
        {
          name: "保存模板",
          display: "Ctrl+S",
        },
      ],
      layerlogs: [],
      logindex: 0,
      click_up: 0,
      depth: 0,
      offset: 0,
      shadow: 0,
      textureVisible: false,
      curTexture: "",
      isPreviewMask: false,
      stageScale: 1,
      scalePercent: 100,
      stagePosition: { x: 0, y: 0 },
      spacePressed: false,
      editorVisible: false,
      curImgCutOut: "",
      SyncJob: null,
      maskdialogVisible: false,
      cropImageUrl: "",
      cropMaskimg: "",
      cropMaskloading: false,
      tool: "brush", // 当前工具：brush/eraser
      brushSize: 70,
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      // 图片相关
      image: null,
      imageWidth: 0,
      imageHeight: 0,
      scale: 1,
      // Canvas上下文
      ctx: null,
      offscreenCtx: null,

      activeName: "",
      lucency: 100,
      dialogTemplVisible: false,
      editIndex: null,
      myCropper: null,
      afterImg: "",
      ScaleX: 1,
      ScaleY: 1,
      fixed: false,
      inputRotate: 0,
      imgFile: "",
      autoCropWidth: 0,
      autoCropHeight: 0,
      dialogVisible: false,
      croploading: false,
      dialogColorVisible: false,
      showColorSelect: true,
      colorForm: {
        name_zh: "",
        name_en: "",
        hex_value: "",
      },
      colorRules: {
        name_zh: [
          {
            required: true,
            max: 50,
            message: "请输入颜色名称",
            trigger: "blur",
          },
        ],
        name_en: [
          {
            required: true,
            max: 50,
            message: "请输入英文名称",
            trigger: "blur",
          },
        ],
        hex_value: [
          {
            required: true,
            pattern: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
            message: "请输入16进制色值",
            trigger: "blur",
          },
        ],
      },
      loading: false,
      dialogSizeVisible: false,
      sizeform: {},
      colorList: [],
      colorloading: false,
      DesignTemplate: [],
      curTemplate: {},
      curDesign: null,
      ruleForm: {},
      colors: [],
      sizes: [],
      classifyList: [{ name: "全部", id: "" }],
      stage: "",
      layer: "",
      fill: "",
      grid: "",
      transformer: "",
      tr: "",
      curImg: "",
      color: "rgba(255,255,255,0)",
      dpiList: [
        { name: 100, value: 100 },
        { name: 150, value: 150 },
        { name: 200, value: 200 },
        { name: 250, value: 250 },
        { name: 300, value: 300 },
      ],
      letters: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      printImgUrl: "https://static.aisanqi.cn/ai/tools/area.png?t=1234567",
    };
  },
  mounted() {
    this.ZoomSupported();
    let percentage = (window.screen.width / 1920).toFixed(2);
    console.log(window.screen.width, percentage);
    this.setZoomPercentage(percentage);
  },
  created() {
    window._this = this;
    colorGetList().then((res) => {
      if (res.data.data.length > 0) {
        this.colorList = res.data.data;
        if (this.$route.query && this.$route.query.id) {
          templateDetail(this.$route.query.id).then((res) => {
            if (res.code == 200) {
              let editData = JSON.parse(res.data.description);
              this.DesignTemplate = editData.DesignTemplate;
              this.curTemplate = editData.curTemplate;
              this.curDesign = editData.curDesign;
              this.colors = editData.colors;
              this.sizes = editData.sizes;
              this.ruleForm = editData.ruleForm;
              this.ruleForm.name = res.data.name;
              this.ruleForm.group = res.data.category_id;
              this.DesignTemplate.forEach((curTemplate) => {
                if (this.curTemplate.color_id == curTemplate.color_id) {
                  this.curTemplate = curTemplate;
                  this.curTemplate.design_list.forEach((curDesign, index) => {
                    if (curDesign.id == this.curDesign.id) {
                      this.curDesign = this.curTemplate.design_list[index];
                    }
                  });
                }
              });
              if (this.curDesign) {
                this.startInit(this.curDesign);
              } else if (
                this.curTemplate &&
                this.curTemplate.design_list &&
                this.curTemplate.design_list.length > 0
              ) {
                this.startInit(this.curTemplate.design_list[0]);
              } else if (
                this.DesignTemplate &&
                this.DesignTemplate.length > 0
              ) {
                this.curTemplate = this.DesignTemplate[0];
                this.startInit(this.curTemplate.design_list[0]);
              } else {
                this.message.warning("请自主选择添加开启编辑");
              }
            } else {
              this.$router.push("/teamResource/template");
            }
            this.messageBox(res);
          });
        } else if (this.$route.query && this.$route.query.colors) {
          this.colors = JSON.parse(this.$route.query.colors);
          this.colors.forEach((color) => {
            let ColorItem = this.showColorItem(color);
            this.DesignTemplate.push({
              color_id: color,
              ColorItem: ColorItem,
              design_list: [],
            });
          });
          if (this.DesignTemplate.length > 0) {
            this.curTemplate = this.DesignTemplate[0];
          }
        }
      }
    });
    this.getCategoryList();
    if (this.$route.query && this.$route.query.ruleForm) {
      this.ruleForm = JSON.parse(this.$route.query.ruleForm);
    }
  },
  watch: {
    lucency(v1, v2) {
      this.curImg.setOpacity(v1 / 100);
    },
    Names: {
      handler(newVal, oldVal) {},
      deep: true,
    },
  },
  computed: {
    formatTooltip() {
      if (this.curImg) {
        this.lucency = opacity(this.curImg);
      }
    },
    Names: function () {
      let namesList = [];
      this.DesignTemplate.forEach((curTemplate) => {
        curTemplate.design_list.forEach((curDesign) => {
          curDesign.layerdata.forEach((attr) => {
            if (attr.printing != undefined) {
              namesList.push(attr.printingname);
            }
          });
        });
      });
      if (this.layer && this.layer.children) {
        this.layer.children.forEach((layer) => {
          if (layer.attrs.printing != undefined) {
            namesList.push(layer.attrs.printingname);
          }
        });
      }
      let names = [...new Set(namesList.map(JSON.stringify))].map(JSON.parse);
      return names;
    },
  },
  methods: {
    setAlignment(v,item){
      if(item.attrs.oattrs){
        item.attrs.oattrs.alignment = v;
      }
    },
    resetCorners(item,isSet=false) {
      const image = new window.Image();
      image.crossOrigin = "anonymous";
      let attrs = JSON.parse(JSON.stringify(item.attrs.oattrs));
      image.onload = () => {
        attrs.image = image;
        attrs.listening = true;
        item.destroy();
        let img = new Konva.Image(attrs);
        img.globalCompositeOperation(item.attrs.globalCompositeOperation);
        img.filters([Konva.Filters.Brighten]);
        img.brightness(item.attrs.brightness);
        this.layer.add(img);
        img.clearCache();
        img.cache();
        this.layer.draw();
        this.curImg = img;
        this.tr.nodes([this.curImg]);
        this.$set(this.curImg.attrs, "oattrs", undefined);
        this.$set(this.curImg.attrs, "corners", undefined);
        this.$set(this.curImg.attrs, "brightness", item.attrs.brightness);
        if(!isSet){
          attrs.Deformation = true;
          this.openDeformation(true, this.curImg);
        }else{
          attrs.Deformation = false;
          this.$set(this.curImg.attrs, "Deformation", false);
        }
      };
      image.src = item.attrs.oattrs.src;
    },
    async openDeformation(v, img) {
      this.curImg = img;
      if (v) {
        this.curCorners = this.getRotatedImageCorners(img);
        this.deformVisible = true;
      } else {
        if(img.attrs.oattrs!=undefined){
          this.resetCorners(img,true);
        }else{
          img.attrs.Deformation = false;
          img.attrs.corners = undefined;
        }
      }
    },
    getRotatedImageCorners(konvaImage) {
      if (!konvaImage) return [];

      // 获取图片位置和变换信息
      const x = konvaImage.x();
      const y = konvaImage.y();
      const width = konvaImage.width() * konvaImage.scaleX();
      const height = konvaImage.height() * konvaImage.scaleY();
      const rotation = (konvaImage.rotation() * Math.PI) / 180; // 转换为弧度

      // 计算中心点
      const centerX = x;
      const centerY = y;

      // 计算未旋转时的四个角（相对于中心点）
      const corners = [
        { x: -width / 2, y: -height / 2 }, // 左上角
        { x: width / 2, y: -height / 2 }, // 右上角
        { x: width / 2, y: height / 2 }, // 右下角
        { x: -width / 2, y: height / 2 }, // 左下角
      ];

      // 旋转并转换为绝对坐标
      const rotatedCorners = corners.map((corner) => {
        const rotatedX =
          corner.x * Math.cos(rotation) - corner.y * Math.sin(rotation);
        const rotatedY =
          corner.x * Math.sin(rotation) + corner.y * Math.cos(rotation);
        return {
          x: rotatedX + centerX,
          y: rotatedY + centerY,
        };
      });
      return rotatedCorners;
    },
    sureDeformation(corners, url) {
      this.curImg.attrs.corners = corners;
      let attrs = JSON.parse(JSON.stringify(this.curImg.attrs));
      const imageDeformation = new window.Image();
      imageDeformation.crossOrigin = "anonymous";
      imageDeformation.onload = () => {
        attrs.image = imageDeformation;
        attrs.src = url;
        if(this.curImg.attrs.oattrs==undefined){
          attrs.curCorners = JSON.parse(JSON.stringify(this.curCorners));
          attrs.listening = false;
          attrs.width = this.curDesign.width;
          attrs.height = this.curDesign.height;
          attrs.scale = { x: 1, y: 1 };
          attrs.offset = { x: 0, y: 0 };
          attrs.x = 0;
          attrs.y = 0;
          attrs.rotation = 0;
          attrs.oattrs = JSON.parse(JSON.stringify(this.curImg.attrs));
          let groupBox = {
            width:this.curImg.attrs.width,
            height:this.curImg.attrs.height,
            offsetX:this.curImg.offsetX(),
            offsetY:this.curImg.offsetY(),
            rotation:this.curImg.attrs.rotation,
            scaleX:this.curImg.scaleX(),
            scaleY:this.curImg.scaleY(),
            x:this.curImg.attrs.x,
            y:this.curImg.attrs.y,
          }
          attrs.groupBox = JSON.parse(JSON.stringify(groupBox));
        }
        this.curImg.destroy();
        let img = new Konva.Image(attrs);
        img.filters([Konva.Filters.Brighten]);
        img.brightness(attrs.oattrs.brightness);
        this.layer.add(img);
        img.clearCache();
        img.cache();
        this.layer.draw();
        this.curImg = img;
        this.$set(this.curImg.attrs, "brightness", attrs.oattrs.brightness);
        this.transformer.children.forEach((item) => {
          item.nodes([]);
        });
        console.log(this.curImg)
        this.$message.warning('变形印花只可调整变形不可移动，可通过操作栏切换选中变形的印花。');
      };
      imageDeformation.src = url;
      this.deformVisible = false;
    },
    updateDraggable(n) {
      console.log(n);
    },
    ZoomSupported() {
      const testElement = document.createElement("div");
      testElement.style.zoom = "1"; // 设置 zoom 属性为 1
      document.body.appendChild(testElement);

      // 获取最终应用到元素上的样式
      const computedZoom = window
        .getComputedStyle(testElement, null)
        .getPropertyValue("zoom");
      console.log(computedZoom);
      // 检查浏览器是否支持 zoom 属性
      if (computedZoom === "1") {
        this.isZoomSupported = true;
      } else {
        this.isZoomSupported = false;
      }
      document.body.removeChild(testElement);
    },
    setZoomPercentage(percentage) {
      if (this.isZoomSupported) {
        let zoomBox = document.getElementById("zoom_box");
        console.log(zoomBox);
        zoomBox.style.zoom = percentage;
        let zoomTempBox = document.getElementById("zoom_temp_box");
        let scaleNum = Number((1 / percentage).toFixed(1));
        zoomTempBox.style.height = (100 * scaleNum) + "vh";
        console.log("成功", zoomBox.style.zoom, percentage);
      } else {
        zoomBox.style.zoom = 1;
        console.log("失败");
      }
    },
    sureTexture(d, o, s) {
      this.curImg.attrs.TextureDepth = d;
      this.curImg.attrs.TextureOffsetValue = o;
      this.curImg.attrs.TextureShadowValue = s;
      this.textureVisible = false;
    },
    closeTexture() {
      this.curImg.attrs.Texture = false;
      this.textureVisible = false;
    },
    async openTexture(v, img) {
      if (v) {
        const tempContainer = document.createElement("div");
        tempContainer.style.display = "none";
        document.body.appendChild(tempContainer);

        // 创建临时Stage
        const stageTemp = new Konva.Stage({
          container: tempContainer,
          width: this.curDesign.width,
          height: this.curDesign.height,
        });

        const layerTemp = new Konva.Layer();
        // 克隆图像
        const imgTemp1 = img.clone();
        imgTemp1.cache();
        layerTemp.add(imgTemp1);

        // 绘制临时Stage
        layerTemp.draw();
        stageTemp.add(layerTemp);
        // 导出为Blob
        this.curTexture = await stageTemp.toDataURL({
          mimeType: "image/png",
        });
        tempContainer.remove();
        this.depth = img.attrs.TextureDepth
          ? img.attrs.TextureDepth
          : 0;
        this.offset = img.attrs.TextureOffsetValue
          ? img.attrs.TextureOffsetValue
          : 0;
        this.shadow = img.attrs.TextureShadowValue
          ? img.attrs.TextureShadowValue
          : 0;
        this.textureVisible = true;
      }
    },
    async previewMask(v, img) {
      this.isPreviewMask = v;
      if (v) {
        let a = [];
        this.layer.children.forEach((item) => {
          let i = item.attrs;
          a.push(i);
        });
        a.push(this.color);
        this.curDesign.layerdata = a;
        let curImg = img.clone();
        curImg.attrs.globalCompositeOperation_copy = JSON.parse(
          JSON.stringify(curImg.attrs.globalCompositeOperation)
        );
        const stampGroup = new Konva.Group({
          x: 0,
          y: 0,
          name: "stampGroup",
          width: this.curDesign.width,
          height: this.curDesign.height,
        });
        let bgImg = await this.loadImage(this.curDesign.url);
        const bgNode = new Konva.Image({
          image: bgImg,
          name: "bgimg",
          width: this.curDesign.width,
          height: this.curDesign.height,
        });
        let maskImg = await this.loadImage(curImg.attrs.maskUrl);
        const maskNode = new Konva.Image({
          image: maskImg,
          name: "bgimg",
          width: this.curDesign.width,
          height: this.curDesign.height,
        });
        curImg.globalCompositeOperation("source-in");
        curImg.cache();
        stampGroup.add(maskNode);
        stampGroup.add(curImg);
        console.log(curImg.attrs.globalCompositeOperation_copy);
        stampGroup.globalCompositeOperation(
          curImg.attrs.globalCompositeOperation_copy
        );
        this.layer.find(".rectTransformer").forEach((element) => {
          element.destroy();
        });
        this.layer.find(".bgimg").forEach((element) => {
          element.destroy();
        });
        this.transformer.children.forEach((item) => {
          item.nodes([]);
        });
        this.bglayer.add(bgNode);
        this.bglayer.draw();
        this.layer.add(stampGroup);
        this.layer.draw();
        this.curImg = curImg;
        this.tr.nodes([this.curImg]);
        console.log(this.layer);
      } else {
        let layerdata = [];
        let curImg = this.layer.findOne(".rectTransformer");
        this.curDesign.layerdata.forEach((attr) => {
          if (attr.printing != undefined && attr.id == curImg.attrs.id) {
            curImg.attrs.globalCompositeOperation =
              curImg.attrs.globalCompositeOperation_copy;
            layerdata.push(curImg.attrs);
          } else {
            layerdata.push(attr);
          }
        });
        this.$set(this.curDesign, "layerdata", layerdata);
        this.layer.find(".stampGroup").forEach((element) => {
          element.destroy();
        });
        this.changeDesign(this.curDesign, true, true, curImg.attrs.id);
      }
    },
    deleteImage(id) {
      if (this.curTemplate.design_list.length == 1) {
        this.$message.warning("已是最后一张轮播图，不可删除");
      } else {
        this.$confirm("是否删除该图片?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          const designlist = this.curTemplate.design_list;
          const delIdx = designlist.findIndex((item) => item.id == id);
          const listlen = designlist.length;
          if (id == this.curDesign.id) {
            if (delIdx == listlen - 1) {
              this.curDesign = designlist[listlen - 2];
              this.changeDesign(designlist[listlen - 2], true);
            } else {
              this.curDesign = designlist[delIdx + 1];
              this.changeDesign(designlist[delIdx + 1], true);
            }
          }
          this.curTemplate.design_list.splice(delIdx, 1);
        });
      }
    },
    addColor() {
      if (this.isPreviewMask) {
        this.$message.warning("请先关闭蒙版实时预览模式");
      } else {
        this.dialogColorVisible = true;
        this.colorForm = {
          name_zh: "",
          name_en: "",
          hex_value: "",
        };
      }
    },
    handleSubmitForm() {
      this.$refs.colorForm.validate((valid) => {
        if (valid) {
          if (this.colorForm.id) {
            colorUpdate(this.colorForm.id, this.colorForm).then((res) => {
              this.$message.success("编辑颜色成功");
              this.dialogColorVisible = false;
              this.getColorList();
            });
          } else {
            this.colorloading = true;
            colorCreate(this.colorForm).then((ress) => {
              colorGetList().then((res) => {
                if (res.data.data.length > 0) {
                  this.colorList = res.data.data;
                  this.colors.push(ress.data.id);
                  this.colorsChange(this.colors);
                  this.dialogColorVisible = false;
                  this.$message.success("新增颜色成功");
                }
                this.colorloading = false;
              });
            });
          }
        }
      });
    },
    resetStage() {
      if (this.stage) {
        this.stageScale = 1;
        this.stagePosition.x = 0;
        this.stagePosition.y = 0;
        this.stage.scale({ x: this.stageScale, y: this.stageScale });
        this.stage.position(this.stagePosition);
      }
    },
    setupEventListeners() {
      window.addEventListener("keydown", this.handleKeyDown);
      window.addEventListener("keyup", this.handleKeyUp);
    },

    handleKeyDown(e) {
      if (e.key === " ") {
        this.spacePressed = true;
        this.stage.draggable(true);
        this.stage.container().style.cursor = "grab";
      }
    },

    handleKeyUp(e) {
      if (e.key === " ") {
        this.spacePressed = false;
        this.stage.draggable(false);
        this.stage.container().style.cursor = "default";
      }
    },
    updateStageScale() {
      if (!this.stage) return;

      this.stage.scale({ x: this.stageScale, y: this.stageScale });
      this.stage.draw();
    },

    handleWheel(e) {
      e.preventDefault();

      // 计算缩放中心点
      const container = this.$refs.thcontainer;
      const containerRect = container.getBoundingClientRect();
      const point = {
        x: e.clientX - containerRect.left,
        y: e.clientY - containerRect.top,
      };

      // 计算缩放前的舞台坐标
      const oldStagePoint = {
        x: (point.x - this.stagePosition.x) / this.stageScale,
        y: (point.y - this.stagePosition.y) / this.stageScale,
      };

      // 计算新的缩放比例
      const delta = e.deltaY > 0 ? 0.95 : 1.05;
      this.stageScale = Math.max(0.1, Math.min(5, this.stageScale * delta));
      this.scalePercent = Math.max(
        10,
        Math.min(500, this.scalePercent * delta)
      );

      // 计算新的位置
      this.stagePosition.x = point.x - oldStagePoint.x * this.stageScale;
      this.stagePosition.y = point.y - oldStagePoint.y * this.stageScale;

      // 应用变换
      this.stage.position(this.stagePosition);
      this.stage.scale({ x: this.stageScale, y: this.stageScale });
      this.stage.draw();
    },
    changeGlobalCompositeOperation(type, img) {
      img.cache();
      img.globalCompositeOperation(type);
      this.layer.draw();
    },
    copyCanvas(item) {
      if (item.id == this.curDesign.id) {
        this.$message.warning("就在当前轮播图，无需复制。");
      } else {
        if (item == "all") {
          this.curTemplate.design_list.forEach((citem) => {
            if (citem.id != this.curDesign.id) {
              let a = [];
              let layerdata = JSON.parse(JSON.stringify(citem.layerdata));
              a.push(layerdata[0]);
              this.layer.children.forEach((item) => {
                let i = item.attrs;
                if (i.name == "rectTransformer") {
                  a.push(i);
                }
              });
              a.push(this.color);
              this.$set(citem, "layerdata", a);
            }
          });
        } else {
          let a = [];
          let layerdata = JSON.parse(JSON.stringify(item.layerdata));
          a.push(layerdata[0]);
          this.layer.children.forEach((item) => {
            let i = item.attrs;
            if (i.name == "rectTransformer") {
              a.push(i);
            }
          });
          a.push(this.color);
          this.$set(item, "layerdata", a);
        }
        this.$message({
          message: "复制成功",
          type: "success",
        });
      }
    },
    sureMask2(url) {
      this.$set(this.curImg.attrs, "maskUrl", url);
      this.editorVisible = false;
    },
    sureMask() {
      this.$set(this.curImg.attrs, "maskUrl", this.cropMaskimg);
      this.maskdialogVisible = false;
    },
    imageCutout() {
      this.loading = true;
      cutout(this.curDesign.url)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("任务生成成功,AI生成中,开始查询AI任务结果");
            this.getSyncJob(res.data.task_id);
          } else {
            this.messageBox(res);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getSyncJob(task_id) {
      clearInterval(this.SyncJob);
      let num = 1;
      let isSyncJob = false;
      this.SyncJob = setInterval(() => {
        if (task_id && !isSyncJob) {
          isSyncJob = true;
          this.$message.warning(`正在第${num}次查询结果.....`);
          getSyncJob(task_id)
            .then((res) => {
              num++;
              if (res.code == 200) {
                this.loading = false;
                clearInterval(this.SyncJob);
                this.curImgCutOut = res.data.imageUrl;
                this.editorVisible = true;
                // this.openDialog(res.data.imageUrl);
                this.messageBox(res);
              } else if (res.code == 1) {
                isSyncJob = false;
              } else {
                this.loading = false;
                this.messageBox(res);
                clearInterval(this.SyncJob);
              }
            })
            .catch((err) => {
              clearInterval(this.SyncJob);
              this.loading = false;
              this.$message.error("接口错误，请重试");
            });
        }
      }, 1000);
    },
    delmaskUrl(img) {
      this.$set(img.attrs, "maskUrl", "");
    },

    // 加载原始图片
    loadImage(url) {
      return new Promise((resolve) => {
        let image = new Image();
        image.crossOrigin = "Anonymous";
        image.onload = () => {
          resolve(image);
        };
        image.src = url;
      });
    },

    // 初始化画布
    initCanvas() {
      const displayCanvas = this.$refs.displayCanvas;

      // 计算缩放比例 (限制最大显示尺寸)
      const maxWidth = 600;
      const maxHeight = 600;
      this.scale = Math.min(
        maxWidth / this.imageWidth,
        maxHeight / this.imageHeight,
        1
      );

      // 设置显示画布尺寸
      displayCanvas.width = this.imageWidth * this.scale;
      displayCanvas.height = this.imageHeight * this.scale;

      // 获取上下文
      this.ctx = displayCanvas.getContext("2d");

      // 绘制原始图片
      this.ctx.drawImage(
        this.image,
        0,
        0,
        displayCanvas.width,
        displayCanvas.height
      );

      // 创建mask画布 (原始分辨率)
      this.maskCanvas = document.createElement("canvas");
      this.maskCanvas.width = this.imageWidth;
      this.maskCanvas.height = this.imageHeight;
      this.maskCtx = this.maskCanvas.getContext("2d");

      // 初始化mask为全黑（透明区域）
      this.maskCtx.fillStyle = "rgba(0, 0, 0, 0)";
      this.maskCtx.fillRect(0, 0, this.imageWidth, this.imageHeight);

      // 添加半透明层用于显示涂抹效果
      this.addPreviewLayer();
    },

    // 添加预览层显示涂抹效果
    addPreviewLayer() {
      // 创建临时canvas用于预览
      this.previewCanvas = document.createElement("canvas");
      this.previewCanvas.width = this.imageWidth;
      this.previewCanvas.height = this.imageHeight;
      this.previewCtx = this.previewCanvas.getContext("2d");

      // 设置预览层样式
      this.previewCtx.fillStyle = "rgba(0, 149, 255, 0.3)";
    },

    // 坐标转换：显示坐标 -> 原始坐标
    transformCoordinate(x, y) {
      return {
        x: x / this.scale,
        y: y / this.scale,
      };
    },

    // 开始绘制
    startDrawing(e) {
      this.isDrawing = true;
      const rect = this.$refs.displayCanvas.getBoundingClientRect();
      const { x, y } = this.transformCoordinate(
        e.clientX - rect.left,
        e.clientY - rect.top
      );
      [this.lastX, this.lastY] = [x, y];
    },

    // 绘制过程
    draw(e) {
      if (!this.isDrawing) return;

      const rect = this.$refs.displayCanvas.getBoundingClientRect();
      const { x, y } = this.transformCoordinate(
        e.clientX - rect.left,
        e.clientY - rect.top
      );

      // 在mask画布上操作
      this.maskCtx.globalCompositeOperation =
        this.tool === "brush" ? "source-over" : "destination-out";

      this.maskCtx.lineWidth = this.brushSize;
      this.maskCtx.lineCap = "round";
      this.maskCtx.lineJoin = "round";
      this.maskCtx.strokeStyle =
        this.tool === "brush" ? "white" : "rgba(0,0,0,1)";

      this.maskCtx.beginPath();
      this.maskCtx.moveTo(this.lastX, this.lastY);
      this.maskCtx.lineTo(x, y);
      this.maskCtx.stroke();

      // 在预览层上操作
      this.previewCtx.globalCompositeOperation =
        this.tool === "brush" ? "source-over" : "destination-out";

      this.previewCtx.lineWidth = this.brushSize;
      this.previewCtx.lineCap = "round";
      this.previewCtx.lineJoin = "round";
      this.previewCtx.strokeStyle =
        this.tool === "brush" ? "rgba(0, 149, 255, 0.3)" : "rgba(0, 0, 0, 1)";

      this.previewCtx.beginPath();
      this.previewCtx.moveTo(this.lastX, this.lastY);
      this.previewCtx.lineTo(x, y);
      this.previewCtx.stroke();

      // 更新显示画布
      this.updateDisplayCanvas();

      [this.lastX, this.lastY] = [x, y];
    },

    // 更新显示画布
    updateDisplayCanvas() {
      // 先清除显示画布
      this.ctx.clearRect(
        0,
        0,
        this.$refs.displayCanvas.width,
        this.$refs.displayCanvas.height
      );

      // 绘制原始图片
      this.ctx.drawImage(
        this.image,
        0,
        0,
        this.$refs.displayCanvas.width,
        this.$refs.displayCanvas.height
      );

      // 创建临时canvas用于缩放预览层
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = this.$refs.displayCanvas.width;
      tempCanvas.height = this.$refs.displayCanvas.height;
      const tempCtx = tempCanvas.getContext("2d");

      // 将预览层绘制到临时canvas（缩放）
      tempCtx.drawImage(
        this.previewCanvas,
        0,
        0,
        this.imageWidth,
        this.imageHeight,
        0,
        0,
        tempCanvas.width,
        tempCanvas.height
      );

      // 将临时canvas绘制到显示画布
      this.ctx.drawImage(tempCanvas, 0, 0);
    },

    // 停止绘制
    stopDrawing() {
      this.isDrawing = false;
    },

    // 清空画布
    clearCanvas() {
      // 重置mask画布
      this.maskCtx.clearRect(0, 0, this.imageWidth, this.imageHeight);
      this.maskCtx.fillStyle = "rgba(0, 0, 0, 0)";
      this.maskCtx.fillRect(0, 0, this.imageWidth, this.imageHeight);

      // 重置预览层
      this.previewCtx.clearRect(0, 0, this.imageWidth, this.imageHeight);

      // 更新显示画布
      this.updateDisplayCanvas();
    },

    // 获取黑白mask
    async getMask() {
      this.cropMaskloading = true;
      // 创建最终mask画布
      const finalMaskCanvas = document.createElement("canvas");
      finalMaskCanvas.width = this.imageWidth;
      finalMaskCanvas.height = this.imageHeight;
      const finalMaskCtx = finalMaskCanvas.getContext("2d");

      // 设置背景为黑色
      finalMaskCtx.fillStyle = "black";
      finalMaskCtx.fillRect(0, 0, this.imageWidth, this.imageHeight);

      // 将涂抹区域绘制为白色
      finalMaskCtx.globalCompositeOperation = "lighten";
      finalMaskCtx.drawImage(this.maskCanvas, 0, 0);
      let svgToBase64image = finalMaskCanvas.toDataURL("image/png");
      let fileimage = this.dataURLtoFile(svgToBase64image, "cropMask.png");
      const formData = new FormData();
      formData.append("image", fileimage);
      uploadImage(formData)
        .then((res) => {
          if (res.code == 200) {
            segment(this.cropImageUrl, res.data.url)
              .then((res) => {
                this.cropMaskloading = false;
                if (res.code == 200) {
                  this.cropMaskimg = res.data.image;
                }
                this.messageBox(res);
              })
              .catch((err) => {
                this.cropMaskloading = false;
              });
          }
        })
        .catch((err) => {
          this.cropMaskloading = false;
        });
    },

    // 重置画布
    resetCanvas() {
      this.clearCanvas();
      this.tool = "brush";
      this.brushSize = 70;
      this.cropMaskimg = "";
    },

    changeBrightness(v, img) {
      img.brightness(v);
      img.clearCache();
      img.cache();
      this.layer.draw();
    },
    uploadMask() {
      this.$refs.maskfile.click();
    },
    addMask(e) {
      let file = e.target.files[0];
      let imgSize = Number(file.size / 1024 / 1024);
      if (imgSize > 20) {
        this.$msgbox({
          title: "",
          message: "文件大小不能超过20MB，请重新上传。",
          type: "warning",
        });
        return;
      }
      let formData = new FormData();
      formData.append("image", file);
      const el = document.getElementsByClassName("input-mask");
      el[0].value = "";
      this.loading = true;
      templateUploadImage(formData)
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res.code == 200) {
            let w = res.data.width;
            let h = res.data.height;
            if (
              Number(w) != Number(this.curDesign.widtho) ||
              Number(h) != Number(this.curDesign.heighto)
            ) {
              this.$message.warning("蒙版分辨率需跟轮播图保持一致！");
            } else {
              this.curImg.attrs.maskUrl = res.data.url;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error);
        });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    saveTemplate() {
      if (this.Names.length == 0) {
        this.$message.warning("请设计添加印花区域");
      } else {
        let a = [];
        this.layer.children.forEach((item) => {
          let i = item.attrs;
          a.push(i);
        });
        a.push(this.color);
        this.curDesign.layerdata = a;
        let description = {
          DesignTemplate: JSON.parse(JSON.stringify(this.DesignTemplate)),
          curTemplate: JSON.parse(JSON.stringify(this.curTemplate)),
          curDesign: JSON.parse(JSON.stringify(this.curDesign)),
          colors: JSON.parse(JSON.stringify(this.colors)),
          sizes: JSON.parse(JSON.stringify(this.sizes)),
          ruleForm: JSON.parse(JSON.stringify(this.ruleForm)),
        };
        let data = {
          name: this.ruleForm.name,
          category_id: this.ruleForm.group == "" ? 0 : this.ruleForm.group,
          carousel_width: this.ruleForm.width,
          carousel_height: this.ruleForm.height,
          colors: this.colors,
          sizes: this.sizes,
          dpi: this.ruleForm.dpi,
          print_names: JSON.stringify(this.Names),
          images: [],
          description: JSON.stringify(description),
        };
        let images = [];
        this.DesignTemplate.forEach((curTemplate) => {
          curTemplate.design_list.forEach((curDesign) => {
            images.push({
              color_id: curTemplate.color_id,
              image_url: curDesign.url,
              width: curDesign.cropwidth,
              height: curDesign.cropheight,
              print_names: JSON.stringify(this.Names),
              layer_content: {
                width: curDesign.width,
                height: curDesign.height,
                layerData: curDesign.layerdata,
              },
            });
          });
        });
        data.images = JSON.stringify(images);
        if (this.$route.query && this.$route.query.id) {
          templateUpdate(this.$route.query.id, data).then((res) => {
            if (res.code == 200) {
              this.$router.push("/teamResource/template");
            }
            this.messageBox(res);
          });
        } else {
          templateCreate(data).then((res) => {
            if (res.code == 200) {
              this.$router.push("/teamResource/template");
            }
            this.messageBox(res);
          });
        }
      }
    },
    delSize(index) {
      console.log(index, "!!!!!!");
      this.sizes.splice(index, 1);
    },
    editSize(size, index) {
      this.editIndex = index + 1;
      this.sizeform = {
        size: size.size,
        cutpieces: [],
      };
      if (this.Names.length > 0) {
        this.Names.forEach((name) => {
          this.sizeform.cutpieces.push({
            name: name,
            width: undefined,
            height: undefined,
          });
        });
        this.dialogSizeVisible = true;
      } else {
        this.$message.warning("暂无印花区域，无法添加尺码~");
      }
    },
    addSizeCutpiece() {
      this.$refs["esizeForm"].validate((valid) => {
        if (valid) {
          if (this.editIndex) {
            this.$set(
              this.sizes,
              this.editIndex - 1,
              JSON.parse(JSON.stringify(this.sizeform))
            );
          } else {
            this.sizes.push(JSON.parse(JSON.stringify(this.sizeform)));
          }
          this.dialogSizeVisible = false;
        }
      });
    },
    addSize() {
      this.editIndex = null;
      this.sizeform = {
        size: "",
        cutpieces: [],
      };
      if (this.Names.length > 0) {
        this.Names.forEach((name) => {
          this.sizeform.cutpieces.push({
            name: name,
            width: undefined,
            height: undefined,
          });
        });
        this.dialogSizeVisible = true;
      } else {
        this.$message.warning("暂无印花区域，无法添加尺码~");
      }
    },
    copyimg(index) {
      let image1 = JSON.parse(JSON.stringify(this.layer.children[index].attrs));
      image1.x += 10;
      image1.y += 10;
      const timestamp = new Date().getTime().toString();
      const image = new window.Image();
      image.crossOrigin = "anonymous";
      image.src = image1.src;
      image.onload = () => {
        image1.image = image;
        image1.id = timestamp;
        this.addElem(image1);
        this.activeName = timestamp;
      };
    },
    keycopyimg(img) {
      let image1 = JSON.parse(JSON.stringify(img.attrs));
      image1.x += 10;
      image1.y += 10;
      const timestamp = new Date().getTime().toString();
      const image = new window.Image();
      image.crossOrigin = "anonymous";
      image.src = image1.src;
      image.onload = () => {
        image1.image = image;
        image1.id = timestamp;
        this.addElem(image1);
        this.jilu();
        this.activeName = timestamp;
      };
    },
    delimg(index) {
      this.transformer.children.forEach((item) => {
        item.nodes([]);
      });
      this.curImg = "";
      this.layer.children[index].destroy();
      this.activeName = "";
      this.layer.children.forEach((c, index) => {
        if (c.attrs.printing != undefined) {
          this.activeName = c.attrs.id;
          this.curImg = c;
          return;
        }
      });
    },
    keydelimg(img) {
      this.transformer.children.forEach((item) => {
        item.nodes([]);
      });
      img.destroy();
      this.curImg = "";
      this.activeName = "";
      this.layer.children.forEach((c, index) => {
        if (c.attrs.printing != undefined) {
          this.activeName = c.attrs.id;
          this.curImg = c;
          return;
        }
      });
      this.jilu();
    },
    cropimage() {
      this.dialogVisible = true;
    },
    changesucai(index) {
      this.curImg = this.layer.children[index];
      this.transformer.children.forEach((item) => {
        item.nodes([]);
      });
      this.tr.nodes([this.curImg]);
    },
    startInit(item) {
      setTimeout(() => {
        if (document.getElementsByClassName("konvajs-content").length > 0) {
          this.changeDesign(item);
        } else {
          this.thInit2(item);
        }
      }, 200);
    },
    thInit2(item) {
      let arr = item.layerdata;
      this.curDesign = item;
      this.thinit2(
        this.curDesign.width,
        this.curDesign.height,
        this.curDesign.widtho,
        this.curDesign.heighto
      );
      setTimeout((e) => {
        this.stage = this.pageStage;
        this.fill = this.pageLayer[0].fillLayer;
        this.bglayer = this.pageLayer[1].bglayer;
        this.layer = this.pageLayer[2].layer;
        this.transformer = this.pageLayer[3].transformer;
        this.grid = this.pageLayer[4].gridLayer;
        this.tr = new Konva.Transformer({
          name: "tr",
          status: "",
          anchorSize: 10,
          anchorCornerRadius: 5,
          borderStrokeWidth: 1,
          anchorFill: "rgb(0, 161, 255)",
          rotationSnaps: [0, 90, 180, 270],
        });
        this.transformer.add(this.tr);
        this.transformer.draw();
        this.changeDesign(this.curDesign, true);
        this.setupEventListeners();
      }, 40);
    },
    moren(url) {
      console.log(url);
      if (url == undefined || url == "") {
        this.$message.error("无素材");
      } else {
        this.loading = true;
        console.log("使用素材！");
        const timestamp = new Date().getTime().toString();
        const image = new window.Image();
        let w, h;
        image.crossOrigin = "anonymous";
        image.src = url;
        const src = url;
        const src1 = url;
        image.onload = () => {
          w = image.width;
          h = image.height;
          console.log(w, h);
          let n = 1;
          let n1 = 1;
          if (w > h) {
            n = w / this.curDesign.width;
            w = this.curDesign.width;
            h = h / n;
            n1 = this.curDesign.height / h;
          } else {
            n = h / this.curDesign.height;
            h = this.curDesign.height;
            w = w / n;
            n1 = this.curDesign.width / w;
          }
          let imgObj = {
            sourceid: 0,
            id: timestamp,
            src: src,
            src1: src1,
            moren: 1,
            brightness: 0,
            maskUrl: "",
            globalCompositeOperation: "source-over",
            printingname: "印花" + this.letters[this.layer.children.length - 1],
            opacity: 1,
            editname: false,
            printing: 0,
            Texture: false,
            TextureDepth: 0,
            TextureOffsetValue: 0,
            TextureShadowValue: 0,
            alignment: 0,
            name: "rectTransformer",
            image: image,
            width: w,
            height: h,
            draggable: true,
            x: (this.curDesign.width - w) / 2 + w / 2,
            y: (this.curDesign.height - h) / 2 + h / 2,
            rotation: 0,
            offset: {
              x: w / 2,
              y: h / 2,
            },
            scaleX: n1 / 2,
            scaleY: n1 / 2,
            left: 0,
            top: 0,
            flipX: 0,
            flipY: 0,
            putu: 0,
            naturalWidth: Number(image.width),
            naturalHeight: Number(image.height),
            canvasZoom: 1,
            marginLeft: 0,
            marginTop: 0,
            angle: 0,
            viewportTransform: [0, 0],
          };
          this.addElem(imgObj);
          this.jilu();
          this.activeName = timestamp;
          this.loading = false;
        };
      }
    },

    addElemnew(imgObj) {
      const layer = this.layer,
        stage = this.stage;
      this.transformer.children.forEach((item) => {
        item.nodes([]);
      });
      let img = new Konva.Image(imgObj);
      img.cache(false);
      layer.add(img);
      if (imgObj.moren != undefined) {
        this.curImg = img;
        this.curImg.cache();
        this.curImg.filters([Konva.Filters.Brighten]);
        if (imgObj.brightness == undefined) {
          imgObj.brightness = 0;
        }
        this.curImg.brightness(imgObj.brightness);
      }
      clickTap(stage, layer, this.tr, "", this.curDesign.id, this.deletCurImg);
      mouseMove(stage);
      dragmove(stage, layer);
      this.keydown(stage);
    },

    addElem(imgObj) {
      const layer = this.layer,
        stage = this.stage;
      this.transformer.children.forEach((item) => {
        item.nodes([]);
      });
      let img = new Konva.Image(imgObj);
      img.cache(false);
      layer.add(img);
      if (imgObj.moren) {
        this.curImg = img;
        this.curImg.cache();
        this.curImg.filters([Konva.Filters.Brighten]);
        this.curImg.brightness(imgObj.brightness);
        console.log(">>>>>>>>>>", this.layer);
      }
      clickTap(stage, layer, this.tr, "", this.curDesign.id, this.deletCurImg);
      mouseMove(stage);
      dragmove(stage, layer);
      this.keydown(stage);
    },
    keydown(stage) {
      const that = this;
      let img = "";
      stage.on("mousedown touchstart", (e) => {
        //点击的是图片
        if (e.target != stage) {
          that.click_up = 1;
          if (e.target.attrs.name === "rectTransformer") {
            that.curImg = e.target;
            img = e.target;
            this.activeName = e.target.attrs.id;
          } else if (e.target.attrs.name === "bgimg") {
            this.tr.nodes([]);
            that.curImg = "";
            img = "";
          } else {
            that.curImg = that.curImg;
            img = that.curImg;
          }
        } else {
          img = "";
          that.curImg = "";
        }
      });
      stage.on("mouseup touchend", (e) => {
        //点击的是图片
        if (that.click_up == 2) {
          that.click_up = 0;
          if(e.target.attrs.name !== "bgimg"){
            that.jilu();
          }
          
        }
      });
      stage.on("mousemove touchmove", (e) => {
        if (that.click_up == 1) {
          that.click_up = 2;
        }
      });
      stage.on("dragend", (e) => {
        this.stagePosition.x = stage.x();
        this.stagePosition.y = stage.y();
      });
      const container = stage.container();
      container.tabIndex = 1;
      container.focus();
      container.addEventListener("keydown", function (e) {
        var ctrlKey = e.ctrlKey;
        var altKey = e.altKey;
        var shiftKey = e.shiftKey;
        if (img !== "" && img.attrs.name == "rectTransformer") {
          if (e.keyCode === 37) {
            that.imgl();
          } else if (e.keyCode === 38) {
            that.imgU();
          } else if (e.keyCode === 39) {
            that.imgR();
          } else if (e.keyCode === 40) {
            that.imgD();
          } else if (ctrlKey && e.keyCode === 90) {
            that.chex();
          } else if (ctrlKey && e.keyCode === 89) {
            that.chonz();
          } else if (e.keyCode === 46) {
            that.kdelimg();
          } else if (ctrlKey && e.keyCode === 83) {
            that.saveDesign();
          } else if (ctrlKey && e.keyCode === 67) {
            that.kcopyimg();
          } else {
            return;
          }
          e.preventDefault();
        }
      });
    },
    saveDesign: debounceFun(() => {
      if (!window._this.isPreviewMask) {
        window._this.saveTemplate();
      } else {
        window._this.$message.warning("请先关闭蒙版实时预览模式");
      }
    }, 20),
    imgl: debounceFun(() => {
      window._this.curImg.x(window._this.curImg.x() - 1);
      window._this.jilu();
    }, 20),
    imgR: debounceFun(() => {
      window._this.curImg.x(window._this.curImg.x() + 1);
      window._this.jilu();
    }, 20),
    imgU: debounceFun(() => {
      window._this.curImg.y(window._this.curImg.y() - 1);
      window._this.jilu();
    }, 20),
    imgD: debounceFun(() => {
      window._this.curImg.y(window._this.curImg.y() + 1);
      window._this.jilu();
    }, 20),
    kcopyimg: debounceFun(() => {
      if (!window._this.isPreviewMask) {
        window._this.keycopyimg(window._this.curImg);
      } else {
        window._this.$message.warning("请先关闭蒙版实时预览模式");
      }
    }, 200),
    kdelimg: debounceFun(() => {
      if (!window._this.isPreviewMask) {
        window._this.keydelimg(window._this.curImg);
      } else {
        window._this.$message.warning("请先关闭蒙版实时预览模式");
      }
    }, 200),
    chex: debounceFun(() => {
      if (!window._this.isPreviewMask) {
        window._this.chexiao();
      } else {
        window._this.$message.warning("请先关闭蒙版实时预览模式");
      }
    }, 20),
    chexiao() {
      if (this.logindex - 1 >= 0) {
        this.logindex--;
        this.imageDesign(this.layerlogs[this.logindex]);
      }
    },
    chonz: debounceFun(() => {
      if (!window._this.isPreviewMask) {
        window._this.chonzuo();
      } else {
        window._this.$message.warning("请先关闭蒙版实时预览模式");
      }
    }, 20),
    chonzuo() {
      if (this.logindex + 1 < this.layerlogs.length) {
        this.logindex++;
        this.imageDesign(this.layerlogs[this.logindex]);
      }
    },
    imageDesign(arr) {
      console.log(this.logindex, arr);
      var that = this;
      if (arr != null) {
        var layerimage = [];
        if (!this.activeName) {
          arr.forEach((c, index) => {
            if (c.printing != undefined) {
              this.activeName = c.id;
              return;
            }
          });
        }
        arr.forEach((c, index) => {
          if (c.image != undefined) {
            let image = new window.Image();
            if (this.activeName == undefined && c.printing != undefined) {
              const timestamp = new Date().getTime().toString();
              c.id = timestamp;
              this.activeName = c.id;
            }
            image.crossOrigin = "anonymous";
            image.src = c.src;
            image.onload = () => {
              c.image = image;
              layerimage[index] = c;
            };
          }
        });
        let time2 = setInterval(() => {
          if (
            layerimage.length == arr.length - 1 &&
            !layerimage.includes(undefined)
          ) {
            that.chehuiemptyCanvas();
            clearInterval(time2);
            layerimage.forEach((c) => {
              that.addElemnew(c);
            });
          }
        }, 100);
      } else {
        that.emptyCanvas();
      }
    },
    jilu() {
      if (!this.isPreviewMask) {
        var that = this;
        let a = [];
        this.transformer.children.forEach((item) => {
          item.nodes([]);
        });
        that.logindex++;
        that.layer.children.forEach((item) => {
          if (item.attrs.image != undefined) {
            let i = item.attrs;
            a.push(i);
          }
        });
        a.push(that.color);
        that.layerlogs[that.logindex] = JSON.parse(JSON.stringify(a));
        that.layerlogs = that.layerlogs.slice(0, that.logindex + 1);
        console.log(that.logindex, that.layerlogs.length);
        console.log("图历史记录", that.layerlogs);
      }
    },
    chehuiemptyCanvas() {
      this.click_up = 0;
      this.stage.off();
      this.stageons(this.curDesign.width, this.curDesign.height);
      this.layer.find(".rectTransformer").forEach((element) => {
        element.destroy();
      });
      this.layer.find(".bgimg").forEach((element) => {
        element.destroy();
      });
      this.bglayer.find(".bgimg").forEach((element) => {
        element.destroy();
      });
      this.transformer.children.forEach((item) => {
        item.nodes([]);
      });
      this.fill.children.forEach((item) => {
        item.destroy();
      });
      this.color = "rgba(255,255,255,0)";
      if (this.grid.find(".grid").length !== 0) {
        this.grid.find(".grid").forEach((item) => {
          item.destroy();
        });
      }
    },
    emptyCanvas() {
      this.click_up = 0;
      this.stage.off();
      this.layerlogs = [];
      this.logindex = 0;
      this.stageons(this.curDesign.width, this.curDesign.height);
      this.layer.find(".rectTransformer").forEach((element) => {
        element.destroy();
      });
      this.layer.find(".bgimg").forEach((element) => {
        element.destroy();
      });
      this.bglayer.find(".bgimg").forEach((element) => {
        element.destroy();
      });
      this.transformer.children.forEach((item) => {
        item.nodes([]);
      });
      this.fill.children.forEach((item) => {
        item.destroy();
      });
      this.color = "rgba(255,255,255,0)";
      if (this.grid.find(".grid").length !== 0) {
        this.grid.find(".grid").forEach((item) => {
          item.destroy();
        });
      }
    },
    changeDesign(Designitem, isfirst, isPreviewMask = false, activeName = "") {
      if (
        (this.curDesign.id != Designitem.id || isfirst) &&
        !this.isPreviewMask
      ) {
        this.isPreviewMask = false;
        if (!isPreviewMask) {
          this.resetStage();
          this.layerlogs = [];
          this.logindex = 0;
        }
        let that = this;
        if (!isfirst) {
          let a = [];
          this.layer.children.forEach((item) => {
            let i = item.attrs;
            a.push(i);
          });
          a.push(this.color);
          this.curDesign.layerdata = a;
        }
        this.emptyCanvas();
        this.curDesign = Designitem;
        this.stage.width(Designitem.width);
        this.stage.height(Designitem.height);
        setTimeout(() => {
          this.addRuler(
            Designitem.width,
            Designitem.height,
            Designitem.widtho,
            Designitem.heighto,
            this.grid
          );
        }, 20);
        let arr = Designitem.layerdata;
        if (arr != null) {
          this.layerlogs[this.logindex] = JSON.parse(JSON.stringify(arr));
          var layerimage = [];
          if (activeName != "") {
            this.activeName = activeName;
          } else {
            this.activeName = "";
            arr.forEach((c, index) => {
              if (c.printing != undefined) {
                this.activeName = c.id;
                return;
              }
            });
          }
          arr.forEach((c, index) => {
            if (c.image != undefined) {
              let image = new window.Image();
              if (this.activeName == undefined && c.printing != undefined) {
                const timestamp = new Date().getTime().toString();
                c.id = timestamp;
                this.activeName = c.id;
              }
              image.crossOrigin = "anonymous";
              image.onload = () => {
                c.image = image;
                layerimage[index] = c;
              };
              image.src = c.src;
            }
          });
          let time2 = setInterval(() => {
            if (
              layerimage.length == arr.length - 1 &&
              !layerimage.includes(undefined)
            ) {
              clearInterval(time2);
              layerimage.forEach((c) => {
                that.addElemnew(c);
              });
              if (arr.length == 2) {
                this.moren(this.printImgUrl);
              }
            }
          }, 100);
        }
      }
      if (this.isPreviewMask) {
        this.$message.warning("请先关闭蒙版实时预览模式");
      }
    },
    uploadImage() {
      this.$refs.file.click();
    },
    addImage(e) {
      let file = e.target.files[0];
      let imgSize = Number(file.size / 1024 / 1024);
      if (imgSize > 20) {
        this.$msgbox({
          title: "",
          message: "文件大小不能超过20MB，请重新上传。",
          type: "warning",
        });
        return;
      }
      let formData = new FormData();
      formData.append("image", file);
      const el = document.getElementsByClassName("input-opacity");
      el[0].value = "";
      this.loading = true;
      templateUploadImage(formData)
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res.code == 200) {
            let id_index = JSON.parse(
              JSON.stringify(this.curTemplate.design_list.length)
            );
            let w = res.data.width;
            let h = res.data.height;
            if (Number(w) > Number(h)) {
              let n = w / 790;
              w = 790;
              h = h / n;
            } else {
              let n = h / 790;
              h = 790;
              w = w / n;
            }
            let a = [];
            let width = res.data.width;
            let height = res.data.height;
            let n = 1;
            let n1 = 1;
            if (width > height) {
              n = width / w;
              width = w;
              height = height / n;
              n1 = h / height;
            } else {
              n = height / h;
              height = h;
              width = width / n;
              n1 = w / width;
            }
            let imgObj = {
              sourceid: 0,
              src: res.data.url,
              src1: res.data.url,
              name: "bgimg",
              image: 1,
              width: width,
              height: height,
              draggable: false,
              x: (w - width) / 2 + width / 2,
              y: (h - height) / 2 + height / 2,
              rotation: 0,
              offset: {
                x: w / 2,
                y: h / 2,
              },
              scaleX: n1,
              scaleY: n1,
              left: 0,
              top: 0,
              flipX: 0,
              flipY: 0,
              putu: 0,
              naturalWidth: res.data.width,
              naturalHeight: res.data.height,
              canvasZoom: 1,
              marginLeft: 0,
              marginTop: 0,
              angle: 0,
              viewportTransform: [0, 0],
            };
            a.push(imgObj);
            a.push(this.color);
            this.curTemplate.design_list.push({
              id: String(this.curTemplate.color_id) + String(id_index + 1),
              url: res.data.url,
              width: w,
              height: h,
              widtho: res.data.width,
              heighto: res.data.height,
              cropwidth: this.ruleForm.width,
              cropheight: this.ruleForm.height,
              layerdata: a,
            });
            if (this.curTemplate.design_list.length == 1) {
              this.startInit(this.curTemplate.design_list[0]);
            }
            console.log(this.curTemplate, this.DesignTemplate);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error);
        });
    },
    colorsChange(v) {
      if (v.length > 0) {
        let DesignTemplate = [];
        this.colors.forEach((color) => {
          let ColorItem = this.showColorItem(color);
          let TemplateItem = this.DesignTemplate.find(
            (item) => item.color_id == color
          );
          if (TemplateItem) {
            DesignTemplate.push(JSON.parse(JSON.stringify(TemplateItem)));
          } else {
            DesignTemplate.push({
              color_id: color,
              ColorItem: ColorItem,
              design_list: [],
            });
          }
        });
        this.DesignTemplate = [];
        this.DesignTemplate = JSON.parse(JSON.stringify(DesignTemplate));
        this.DesignTemplate.forEach((curTemplate) => {
          if (this.curTemplate.color_id == curTemplate.color_id) {
            this.curTemplate = curTemplate;
            this.curTemplate.design_list.forEach((curDesign, index) => {
              if (curDesign.id == this.curDesign.id) {
                let a = [];
                this.layer.children.forEach((item) => {
                  let i = item.attrs;
                  a.push(i);
                });
                a.push(this.color);
                this.curTemplate.design_list[index].layerdata = a;
                this.curDesign = this.curTemplate.design_list[index];
              }
            });
          }
        });
      }
    },
    changeTemplate(item) {
      if (!this.isPreviewMask) {
        this.curTemplate = item;
        if (this.curTemplate.design_list.length > 0) {
          this.changeDesign(this.curTemplate.design_list[0]);
        }
      } else {
        this.$message.warning("请先关闭蒙版实时预览模式");
      }
    },
    showCategory(id) {
      let CategoryItem = this.classifyList.find((item) => item.id == id);
      let name = "无";
      if (CategoryItem) {
        name = CategoryItem.name;
      }
      return name;
    },
    showColorItem(id) {
      let ColorItem = {
        hex_value: "#000000",
        name_en: "无",
        name_zh: "无",
      };
      ColorItem = this.colorList.find((item) => item.id == id);
      return ColorItem;
    },
    getCategoryList() {
      categoryGetList({ page: 1, limit: 1000 }).then((res) => {
        this.classifyList = this.classifyList.concat(res.data);
        console.log(this.classifyList);
      });
    },
    getColorList(keyword) {
      this.colorloading = true;
      colorGetList({ keyword }).then((res) => {
        if (res.data.data.length > 0) {
          this.colorList = res.data.data;
        }
        this.colorloading = false;
      });
    },
    show() {
      setTimeout(() => {
        this.initcrop();
      }, 0);
    },
    closeCropper() {
      console.log("清空crop图片");
      this.myCropper.destroy();
      this.dialogVisible = false;
    },
    initcrop() {
      this.autoCropWidth = 0;
      this.autoCropHeight = 0;
      this.myCropper = new Cropper(this.$refs.imagecrop, {
        viewMode: 1,
        dragMode: "move",
        preview: ".before",
        background: false,
        autoCropArea: 1,
        zoomOnWheel: true,
        aspectRatio: this.curDesign.cropwidth / this.curDesign.cropheight,
        minCropBoxWidth: 1,
        minCropBoxHeight: 1,
      });
      this.autoCropWidth = JSON.parse(JSON.stringify(this.curDesign.cropwidth));
      this.autoCropHeight = JSON.parse(
        JSON.stringify(this.curDesign.cropheight)
      );
      this.myCropper.replace(this.curDesign.url);
    },
    setcropAspectRatio(width, height) {
      this.myCropper.setAspectRatio(width / height);
    },
    dataURLtoFile: function (dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    sureSava() {
      this.croploading = true;
      let match = this.curDesign.url.match(/\.([^.]+)$/);
      this.afterImg = this.myCropper
        .getCroppedCanvas({
          imageSmoothingQuality: "high",
        })
        .toDataURL(`image/${match ? match[1] : "png"}`);
      let fileimage = this.dataURLtoFile(
        this.afterImg,
        `crop.${match ? match[1] : "png"}`
      );
      console.log(fileimage);
      let imgSize = Number(fileimage.size / 1024 / 1024);
      if (imgSize > 20) {
        this.croploading = false;
        this.$msgbox({
          title: "",
          message: "裁切画质较高，图像大小已超过20MB，请重新框选。",
          type: "warning",
        });
        return;
      } else {
        const formData = new FormData();
        formData.append("image", fileimage);
        templateUploadImage(formData)
          .then((res) => {
            this.croploading = false;
            if (res.code == 200) {
              let w = res.data.width;
              let h = res.data.height;
              if (Number(w) > Number(h)) {
                let n = w / 790;
                w = 790;
                h = h / n;
              } else {
                let n = h / 790;
                h = 790;
                w = w / n;
              }
              let a = [];
              let width = res.data.width;
              let height = res.data.height;
              let n = 1;
              let n1 = 1;
              if (width > height) {
                n = width / w;
                width = w;
                height = height / n;
                n1 = h / height;
              } else {
                n = height / h;
                height = h;
                width = width / n;
                n1 = w / width;
              }
              let imgObj = {
                sourceid: 0,
                src: res.data.url,
                src1: res.data.url,
                name: "bgimg",
                image: 1,
                width: width,
                height: height,
                draggable: false,
                x: (w - width) / 2 + width / 2,
                y: (h - height) / 2 + height / 2,
                rotation: 0,
                offset: {
                  x: w / 2,
                  y: h / 2,
                },
                scaleX: n1,
                scaleY: n1,
                left: 0,
                top: 0,
                flipX: 0,
                flipY: 0,
                putu: 0,
                naturalWidth: res.data.width,
                naturalHeight: res.data.height,
                canvasZoom: 1,
                marginLeft: 0,
                marginTop: 0,
                angle: 0,
                viewportTransform: [0, 0],
              };
              a.push(imgObj);
              a.push(this.color);
              this.curDesign.url = res.data.url;
              this.curDesign.width = w;
              this.curDesign.height = h;
              this.curDesign.widtho = res.data.width;
              this.curDesign.heighto = res.data.height;
              this.curDesign.layerdata = a;
              this.dialogVisible = false;
              this.changeDesign(this.curDesign, true);
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$message.error(error);
          });
      }
    },
    // 缩放
    cropperzoom(val) {
      this.myCropper.zoom(val);
    },
    // 重置
    cropperReset() {
      this.myCropper.reset();
      this.ScaleX = 1;
      this.ScaleY = 1;
    },
    // 移动
    croppermove(val1, val2) {
      this.myCropper.move(val1, val2);
    },
    // 旋转
    cropperRotate(val) {
      this.myCropper.rotate(val);
    },
    // 绝对角度旋转
    cropperrotateTo(val) {
      this.myCropper.rotateTo(val);
    },
    // X轴翻转
    cropperScaleX() {
      this.ScaleX = -this.ScaleX;
      if (
        this.myCropper.getImageData().rotate === -90 ||
        this.myCropper.getImageData().rotate === 90
      ) {
        this.myCropper.scaleY(this.ScaleX);
      } else {
        this.myCropper.scaleX(this.ScaleX);
      }
    },
    // y轴翻转
    cropperScaleY() {
      // console.log(this.myCropper.getImageData().rotate)
      this.ScaleY = -this.ScaleY;
      if (
        this.myCropper.getImageData().rotate === -90 ||
        this.myCropper.getImageData().rotate === 90
      ) {
        this.myCropper.scaleX(this.ScaleY);
      } else {
        this.myCropper.scaleY(this.ScaleY);
      }
    },
    goBack() {
      this.$confirm("是否退出编辑?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push("/teamResource/template");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.maskDialog {
  /deep/.el-dialog__body {
    font-size: 0 !important;
  }
}
.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}

.size-label {
  margin-left: 10px;
  font-size: 14px;
  color: #606266;
}

.canvas-container {
  overflow: auto;
  justify-content: center;
  display: flex;
}

canvas {
  display: block;
  background: #f0f0f0;
  cursor: crosshair;
}
</style>
<style lang="scss" scoped>
.cropDialog {
  ::v-deep .el-dialog {
    border-radius: 15px;
    overflow: hidden;
    backdrop-filter: blur(10px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5) !important;
  }

  ::v-deep .el-dialog__header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 20px;
  }

  ::v-deep .el-dialog__title {
    color: #feb47b !important;
    font-size: 1.4rem;
    font-weight: 600;
  }

  ::v-deep .el-dialog__body {
    padding: 0 20px 20px !important;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 22px;
  }

  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #ff7e5f !important;
    font-size: 1.4rem;
  }

  ::v-deep .dialog-content {
    padding: 0 15px;
  }
}
.keylist {
  position: absolute;
  top: -58px;
  left: 0;
  width: 250px;
  background-color: #FFFFFF;
  // color: white;
  border: 0;
  .keydow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    // color: white;

    .keybox {
      display: inline-block;
      height: 16px;
      margin: 0 2px 2px;
      padding: 0 4px;
      background-color: var(--p-surface, #fff);
      box-shadow: 0 0 0 1px var(--p-border-subdued, #c4cdd5),
        0 2px 0 0 var(--p-surface, #fff),
        0 2px 0 1px var(--p-border-subdued, #c4cdd5);
      border-radius: var(--p-border-radius-base, 3px);
      font-family: -apple-system, BlinkMacSystemFont, San Francisco, Segoe UI,
        Roboto, Helvetica Neue, sans-serif;
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      color: var(--p-text-subdued, #637381);
      text-align: center;
      min-width: 20px;
      -webkit-user-select: none;
      user-select: none;
    }
  }
}
.sizeform_box {
  display: flex;
  align-items: center;
  .el-input {
    width: 20%;
    /deep/ .el-input-group__prepend {
      border-radius: 8px;
      // background: #FFFFFF;
      // color: #ffffff;
      border: 1px solid #525459;
      border-right: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      padding: 0 8px;
    }
    /deep/ .el-input__inner {
      border-left: 0 !important;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }
  }
  .sizeselect_box {
    display: flex;
    align-items: center;
    border-radius: 8px;
    background: rgba(56, 69, 75, 0.05);
    height: 56px;
    border: 1px solid #525459;
    font-size: 12px;
    padding: 16px 8px;
    margin-left: 4%;
    .size_box {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      overflow: hidden;
    }
    .size_item {
      cursor: pointer;
      font-size: 12px;
      // color: white;
      border-radius: 4px;
      flex-shrink: 0;
      height: 24px;
      margin-left: 8px;
      padding: 0 4px;
      line-height: 24px;
      img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
      }
    }
  }
}
.sizeselect_box {
  display: flex;
  align-items: center;
  border-radius: 8px;
  background: rgba(56, 69, 75, 0.05);
  height: 56px;
  border: 1px solid #dcdfe6;
  font-size: 12px;
  padding: 16px 8px;
  margin-left: 4%;
  .size_box {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
  }
  .size_item {
    cursor: pointer;
    font-size: 12px;
    // color: white;
    border-radius: 4px;
    // background: #29334f;
    border: 1px solid #BFBFBF;
    flex-shrink: 0;
    height: 24px;
    margin-left: 8px;
    padding: 0 4px;
    line-height: 24px;
    img {
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }
}
::v-deep .popper__arrow {
  display: none !important;
}
.size_option {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 30px;
  font-size: 12px;
  // color: white;
  img {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    align-self: center;
    margin-right: 11px;
  }
  .size_box1 {
    align-self: center;
    display: flex;
    flex-direction: row;
  }
}
.el-dropdown-menu__item :hover {
  // color: #FFFFFF;
  font-weight: bold;
}
.color_label {
  height: 12px;
  width: 12px;
  display: inline-block;
  border: 1px solid #cdcdcd;
  margin-left: 8px;
  border-radius: 4px;
}
.temp_box {
  display: flex;
  justify-content: space-between;
  padding: 24px;
  height: 100vh;
  .temp_l {
    min-width: 357px;
    .temp_title {
      padding: 8px 16px;
      display: flex;
      align-items: center;
      border-radius: 8px;
      background: #FFFFFF;
      .el-icon-arrow-left {
        cursor: pointer;
        font-weight: 700;
        font-size: 12px;
      }
      .temp_titlec {
        margin: 0 32px 0 16px;
        font-size: 12px;
        width: 76%;
        .temp_titlem {
          font-size: 18px;
          font-weight: 600;
          letter-spacing: 1px;
          margin-bottom: 8px;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
    .temp_l_scroll {
      margin-top: 32px;
      height: calc(100% - 83px);
      overflow: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .temp_sku_box {
      border-radius: 8px;
      background: #FFFFFF;
      margin-bottom: 32px;
      .el-collapse {
        border-top: none;
        padding: 0 16px 10px;
        border-bottom-color: #737373;
        /deep/ .el-collapse-item__header {
          background: transparent;
          // color: #ffffff;
          border-bottom: none;
          .size_box {
            width: 33%;
            display: inline-block;
          }
          .el-collapse-item__arrow {
            margin: 0 0 0 auto;
            font-weight: 700;
          }
        }
        /deep/ .el-collapse-item__wrap {
          background: transparent;
          border-bottom: none;
          .el-collapse-item__content {
            // color: #ffffff;
            padding-bottom: 0;
            .sku_item {
              padding: 11px 16px 11px 8px;
              line-height: 42px;
              margin-bottom: 14px;
              font-size: 14px;
              display: flex;
              align-items: center;
              cursor: pointer;
              .color_box {
                width: 18px;
                height: 18px;
                display: inline-block;
                margin-right: 16px;
                border-radius: 50%;
              }
              .size_box {
                width: 33%;
                display: inline-block;
              }
              .el-icon-edit {
                margin-left: auto;
                display: none;
              }
              .el-icon-delete {
                margin-left: 12px;
                display: none;
              }
              &:hover {
                border-radius: 4px;
                background: rgba(56, 69, 75, 0.05);
                .el-icon-edit {
                  display: inline-block;
                }
                .el-icon-delete {
                  display: inline-block;
                }
              }
            }
            .activeTemplate {
              border-radius: 4px;
              background: rgba(56, 69, 75, 0.05);
              .el-icon-edit {
                display: inline-block;
              }
            }
          }
        }
      }
      .temp_sku_add {
        font-size: 12px;
        padding: 18px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .temp_c {
    display: grid;
    place-items: center;
    grid-auto-flow: column;
    grid-gap: 24px;
    height: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .temp_emptyout {
      border-radius: 8px;
      background: #FFFFFF;
      padding: 24px;
      width: 600px;
      height: calc(100vh - 160px);
      .temp_empty {
        border-radius: 8px;
        border: 1px dashed #bfbfbf;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        cursor: pointer;
        img {
          margin-bottom: 8px;
        }
      }
    }
    .temp_banner {
      display: flex;
      flex-direction: column;
      width: 132px;
      height: 793px;
      border-radius: 8px;
      background: #FFFFFF;
      border-top: transparent;
      .temp_banner_t {
        margin: 12px;
        text-align: center;
        height: calc(100% - 45px);
        overflow: auto;
        &::-webkit-scrollbar {
          display: none;
        }
        .temp_banner_img {
          margin-bottom: 12px;
          position: relative;
          .temp_banner_del {
            position: absolute;
            right: 0;
            top: 0;
            padding: 0 2px;
            background: rgba(181, 181, 181, 0.4);
            font-size: 14px;
            cursor: pointer;
            border-bottom-left-radius: 4px;
          }
          img {
            padding: 4px;
            width: 106px;
            object-fit: cover;
            vertical-align: middle;
          }
          &.active {
            border: 1px solid #192038;
          }
        }
      }
      .temp_banner_add {
        cursor: pointer;
        background: #acaf0b;
        color: #FFFFFF;
        // border-top: 1px solid #737373;
        border-radius: 0px 0px 8px 8px;
        font-size: 12px;
        padding: 16px 0 11px;
        text-align: center;
      }
    }
    .temp_main {
      width: 790px;
      height: 790px;
      display: flex;
      position: relative;
      justify-content: center;
      background: #2c3e50;
      background-image: linear-gradient(45deg, #34495e 25%, transparent 25%),
        linear-gradient(-45deg, #34495e 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #34495e 75%),
        linear-gradient(-45deg, transparent 75%, #34495e 75%);
      background-size: 20px 20px;
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
      cursor: default;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: middle;
      }
      .copy {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        z-index: 2;

        p {
          border-radius: 4px;
          font-size: 12px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          width: 60px;
          height: 22px;
          background-color: #FFFFFF;
          border: 1px solid #FFFFFF;
        }

        &:hover .copy-list {
          display: flex;
        }

        .copy-list {
          width: 60px;
          border-radius: 4px;
          background-color: #FFFFFF;
          display: none;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          z-index: 1000;

          .item {
            border-radius: 4px;
            font-size: 12px;
            text-align: center;
            cursor: pointer;
            width: 60px;
            height: 22px;
            line-height: 22px;

            &:hover {
              background: #151a30;
            }
          }
        }
      }
    }
    .temp_resize {
      cursor: pointer;
      margin-top: 35px;
      border-radius: 8px;
      background: #FFFFFF;
      padding: 6px 13px;
      text-align: center;
      color: #595959;
      font-size: 12px;
      align-self: start;
    }
  }
  .temp_r {
    width: 382px;
    margin-top: 35px;
    display: flex;
    flex-direction: column;

    .temp_add_print {
      border-radius: 8px;
      background: #acaf0b;
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-size: 18px;
      color: #FFFFFF;
      margin-bottom: 32px;
      padding: 0;
      border: none;
      i {
        font-size: 16px;
      }
    }
    .temp_print_scroll {
      flex: 1;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      /deep/ .el-tabs__item.is-active {
        color: #409eff !important;
      }
      /deep/ .el-tabs__item {
        line-height: normal;
        height: auto;
      }
      /deep/ .el-tabs__nav-prev {
        line-height: 27px;
      }
      /deep/ .el-tabs__nav-next {
        line-height: 27px;
      }
    }
    .temp_print_box {
      padding: 16px;
      border-radius: 8px;
      background: #FFFFFF;
      margin-bottom: 24px;
      /deep/.el-radio-.el-radio-button:first-child {
        border-left: 0;
      }
      /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        box-shadow: -1px 0 0 0 #409eff;
      }
      .temp_print_t {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        .el-icon-edit {
          cursor: pointer;
          align-self: center;
        }
        i {
          margin-left: 12px;
        }
        /deep/.el-input__inner {
          // background: #151a30;
          color: #737373;
        }
      }
      .temp_print_tip {
        color: #737373;
        font-size: 12px;
        margin-top: 24px;
        /deep/.el-switch__label {
          color: #737373;
        }
        /deep/.el-switch__label.is-active {
          color: #409eff;
        }
      }
      .print_fill_out {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;
        .print_fill_item {
          cursor: pointer;
          border-radius: 4px;
          background: rgba(56, 69, 75, 0.05);
          width: 98px;
          height: 98px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 8px;
          &.active {
            background: #FFFFFF;
            border: 1px solid #192038;
          }
        }
        .temp_print_tip {
          text-align: center;
        }
      }
    }
    .temp_mask {
      font-size: 20px;
      border-radius: 8px;
      background: #4099ff;
      border: none;
      color: white;
      width: 100%;
      height: 44px;
    }
    .temp_save {
      font-size: 24px;
      border-radius: 8px;
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      border: none;
      color: #F7F8FA;
      width: 100%;
      height: 64px;
    }
  }
}
.cropper {
  border: 1px solid #fff;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC);

  img {
    width: 100%;
    opacity: 0;
  }
}

.cropper-head {
  display: flex;
  flex-direction: row;
  padding: 10px 260px;
  padding-right: 0;
  align-items: center;

  .text1 {
    font-size: 18px;
    font-weight: bold;
    color: #595959;
  }

  .text2 {
    font-size: 14px;
    font-weight: bold;
    color: #a6a6a6;
    margin-left: 420px;
    align-items: center;
    display: flex;

    img {
      margin-right: 10px;
      width: 14px;
    }
  }
}

.cropper-content {
  display: flex;

  // display: -webkit-flex;
  // justify-content: flex-end;
  // -webkit-justify-content: flex-end;
  .movetext {
    writing-mode: tb-rl;
    font-size: 12px;
    font-weight: bold;
    color: #a6a6a6;
    padding-right: 30px;
    letter-spacing: 2px;

    img {
      margin-bottom: 10px;
    }
  }
}

.cropper-content .cropper {
  width: 640px;
  height: 640px;
  overflow: hidden;
}

.cropper-content .show-preview {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  overflow: hidden;
  /* border: 1px solid #cccccc; */
  background: #cccccc;
  margin-left: 40px;
}

.preview {
  overflow: hidden;
  border: 1px solid #468ac8;
  background: #cccccc;
}
.footer-btn {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-btn .scope-btn {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  margin-bottom: 20px;
  img {
    margin-bottom: 4px;
    object-fit: contain;
  }
  /deep/ .el-button {
    background: rgba(56, 69, 75, 0.05);
    color: #737373;
  }
  /deep/ .el-input__inner {
    background: rgba(56, 69, 75, 0.05);
    color: #737373;
  }
}

.footer-btn .scope-btn span {
  display: inline-block;
  padding: 10px;
  border-radius: 5px;
  color: #737373;
  cursor: pointer;
}

.footer-btn .upload-btn {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  justify-content: end;
  /deep/ .el-button {
    background: rgba(56, 69, 75, 0.05);
    color: #737373;
  }
}
</style>